
// import React, { useState, useEffect } from 'react';
// import '../styles/CompanyPolicy.css';
// import logoWhite from '../assets/logowhite.png';

// export const GENESIS_POLICIES = [
//   {
//     id: 1,
//     title: "Probation Policy",
//     icon: "⏳",
//     content: (

//       <div className="policy-details-text">
//         <header className="policy-header-container">

//         </header>
//         <section>
//           <p><strong>1. Purpose & Scope</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               The purpose of this policy is to define the terms and conditions applicable during the six-month probationary period for new employees at Genesis Tech Engineers Pvt. Ltd. This period is intended to evaluate the employee’s performance, compatibility with company culture, and overall suitability for the role. This policy applies to all newly hired employees who are undergoing their initial six-month probationary period at Genesis Tech Engineers Pvt. Ltd.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>2. Duration and Assessment</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>All new employees must undergo a probationary period lasting six (6) months from their official start date. The probationary period is designed to assess the employee’s performance and fit within the company.</li>

//             <li>Your manager at the end of your 6 month probation period may decide to extend your probation period for 3 additional months. This is so that your manager still believes in your abilities and that your performance will meet the requirements of clearing the probation period.</li>

//             <li>There is only one time extension to probation duration.</li>

//             <li>Manager will submit a performance review at the end of your probation period to HR.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>3. Leave Entitlements & Penalties</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>During the probationary period, employees are not entitled to any leaves. Only emergency case leaves will be approved and will be counted towards the earned leave.</li>

//             <li>If leaves are taken the penalty will be +1 or +2 additional leaves deducted from your earned leave based on scenarios mentioned below.</li>

//             <li>If employee takes below or up to 2 days leave during probation, then +1 rule will apply i.e. 1 additional earned leave will deducted.</li>

//             <li>If an employee takes leave for more than 2 days during probation then +2 rule will apply i.e additional 2 days of earned leave will be deducted from the overall leaves they applied.</li>
//           </ul>
//         </section>
//         <section>
//           <p><strong>4. Performance Review & Confirmation</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Performance evaluations will be conducted periodically throughout the probationary period to assess the employee’s performance, adherence to company policies, and overall suitability for the position. A formal review will occur at the end of the probationary period to determine whether the employee will be confirmed as a permanent staff member.
//             </li>
//           </ul>
//         </section>

//         <section className="policy-note-red">
//           <p><strong>5. Termination</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employment may be terminated at any time during the probationary period, with or without notice, if the employee’s performance or conduct does not meet the standards set by Genesis Tech Engineers Pvt. Ltd. The standard notice period, as outlined in the employment contract, will apply unless otherwise specified.
//             </li>
//           </ul>
//         </section>
//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           PROBATION POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },
//   {
//     id: 2,
//     title: "WFH Policy",
//     icon: "🏠",
//     content: (
//       <div className="policy-details-text">
//         <section style={{ marginBottom: '20px' }}>
//           <p><strong>1. Purpose:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               The Work from Home (WFH) option is provided as an additional benefit to support employees in extreme case of emergency, a personal obligation that may prevent office attendance. This allows employees to work from a location other than the office on a limited basis, as long as they can effectively fulfill their responsibilities without disrupting daily operations or team productivity. At Genesis Tech we do not entertain any WFH request unless the reason is compelling. The reason should be fully disclosed and explained to manager in order for the request to be considered with an awareness of high chances of the request getting denied.
//             </li>
//           </ul>
//         </section>
//         <section style={{ marginBottom: '15px' }}>
//           <p><strong>Annual WFH Allocation:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               WFH approvals are as per manager discretion. General purpose WFH requests will not be approved.
//             </li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <strong>2. Request Process:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>WFH requests should be submitted to the manager by writing an email at least 2 days in advance describing the detailed reason for request.</li>
//             <li>If the manager does not respond to your email by the date of when you want to start your WFH you must consider that the request is rejected.</li>
//             <li>Requesting WFH that does not fit the 2 day request window will be denied regardless of the reason.</li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <p><strong>3. Work Hours:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees must adhere to their regular work hours while working from home. Availability during working hours is mandatory.
//             </li>
//           </ul>
//         </section>
//         <section style={{ marginBottom: '15px' }}>
//           <strong>4. Communication:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Employees must remain reachable via email, phone, and messaging platforms throughout the WFH day.</li>
//             <li>Regular checking and status updates should be maintained with the team.</li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <strong>5. Workspace Requirements:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Employees must ensure a suitable and productive workspace at home, free from distractions.</li>
//             <li>Reliable internet access is mandatory to maintain connectivity and productivity.</li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <strong>6. Security and Compliance:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Employees must adhere to all company data security policies while working from home.</li>
//             <li>Confidential company information must be handled with the same level of security as in the office.</li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <strong>7. Performance Expectations:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Approved WFH must not result in you loosing your job due to lack of performance. No future WFH will be granted to such individuals.</li>
//             <li>Employees are expected to maintain the same level of productivity and performance while working from home.</li>
//             <li>Deliverables and deadlines remain unchanged unless otherwise communicated.</li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <p><strong>8. Technology and Equipment:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees are responsible for ensuring their home office setup (computer, software, internet) is adequate for work tasks.
//             </li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <strong>9. Reporting:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Employees must report their daily activities and tasks completed in their respective work log tracker at the end of each WFH day.</li>
//             <li>Any issues or challenges encountered should be communicated promptly.</li>
//           </ul>
//         </section>


//         <section style={{ marginBottom: '15px' }}>
//           <strong>10.Wedding :</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Employees are entitled to take maximum 1 week of WFH for the purpose of wedding.</li>

//           </ul>
//         </section>


//         <section style={{ marginTop: '20px', padding: '15px', border: '1px solid #ff4444', borderRadius: '8px', background: 'rgba(255, 68, 68, 0.05)' }}>
//           <strong>11. Exceptions:</strong>
//           <p>Exceptions: There are no exceptions to this WFH policy. WFH is very difficult request to be approved. A strong reason which your manager can agree to is mandatory.</p>
//         </section>

//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           WFH POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },
//   {
//     id: 3,
//     title: "General Policy",
//     icon: "📅",
//     content: (
//       <div className="policy-details-text">
//         <header className="policy-header-container">

//         </header>
//         <section>
//           <strong>1. Leave Entitlements</strong>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>The employee is entitled to take 12 days of paid sick leaves (SL) in a year, 11 days of earned leaves (EL) in a year which is earned in proportion to total months of service has been completed.</li>
//             <li>The Sick Leave (SL) and Earned Leave (EL) will be prorated based on your joining date. E.g. If your joining date is 13th June, your account will show 10 days of SL available for that financial year and accordingly EL will be accumulated with every month of your service at Genesis except for the month of March.</li>
//             <li>Employees will be entitled to 10 public holidays mentioned under the leave policy every financial year</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>2. Carry Forward Rules</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>Other than the earned leaves, the employee cannot carry forward any leaves to next year.</li>

//             <li>Genesis Tech will encash the total available earned leaves at the time of leaving the company.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>3. Encashment Limit</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>Maximum number of earned leaves that can be carried forward over the period of service is 45 days.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>4. Consecutive leaves:</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>Maximum number of leaves that can be taken together in one slot – 1wk (5 business days)</li>

//             <li>Consecutive leaves beyond 2 days must be applied as earned leave.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>5. Leave quota:</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>Any leaves taken beyond your allocated leave balance will be considered unpaid and will result in pay deduction.</li>

//             <li>Earned leaves are earned 1 per month of service completed except in the month of March.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>6. Sick Leaves</strong></p>

//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>
//               Sick leaves up to 2 days do not require any medical certificate/documentation to be provided and can be applied as sick leave.
//             </li>

//             <li>
//               Medical leaves greater than 2 days consecutively will mandatorily require medical documentation to be submitted for it to be considered as sick leave. Medical leaves greater than 2 days may fall into one of the following two categories-

//               <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>

//                 <li>
//                   <strong>Pre-planned medical leave</strong>

//                   <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
//                     <li>This includes any planned medical appointments that you are already aware of or any medical emergency you face.</li>
//                     <li>Employees must submit the medical certificate/prescription note latest within 2 days of returning from leave for the leave to be considered as sick leave.</li>
//                     <li>Process to apply:

//                       <ul style={{ listStyleType: "square", paddingLeft: "20px" }}>
//                         <li>Apply for sick leave in the system before going on leave.</li>
//                         <li>It will auto change to Earned Leave upon submission.</li>
//                         <li>Once you come back from leave you have 2 days to submit the medical documentation proof.</li>
//                         <li>You will have to log in back to the system and upload the documentation.</li>
//                         <li>Notification will go to the manager and once they accept the proof your leave will be converted from earned leave to sick leave.</li>
//                         <li>Failure to submit medical documentation within 2 days of return will result in the leave to be considered as earned leave.</li>
//                       </ul>

//                     </li>
//                   </ul>
//                 </li>

//                 <li>
//                   <strong>Non-pre-planned medical leaves:</strong>

//                   <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
//                     <li>You are not expected to apply for these leaves before going on leave as this is scenario of emergency and we are aware you may not have laptop access.</li>
//                     <li>Process to apply:

//                       <ul style={{ listStyleType: "square", paddingLeft: "20px" }}>
//                         <li>This is backdated leave.</li>
//                         <li>Apply for sick leave in the system within 2 days of rejoining the work.</li>
//                         <li>As this is post the medical event we expect you to have medical documentation proof ready before you apply.</li>
//                         <li>At the time of application, you must upload the medical documentation proof.</li>
//                         <li>Failure to do so will change the leave to a earned leave category.</li>
//                       </ul>

//                     </li>
//                   </ul>
//                 </li>

//                 <li>
//                   <strong>Note:</strong> Notification will go to the manager and once they accept the proof your leave will be converted from earned leave to sick leave.
//                 </li>

//               </ul>
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>7. Professionalism and respecting others personal time:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Stop sending messages on weekends:
//               <ol style={{ paddingLeft: "20px", marginTop: "6px" }}>
//                 <li>Asking for leave on Monday.</li>
//                 <li>Being delayed to office on any workday particularly Monday.</li>
//               </ol>
//             </li>

//             <li>
//               If it is extremely urgent call your manager.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>8. Leave requests and documentation:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employee must request leave through GTELinq and add notification to customers calendar and messaging portals like teams and outlook upon leave being approved and prior to going on OOP.
//               <ul style={{ paddingLeft: "20px", marginTop: "6px" }}>
//                 <li>
//                   <em>e.g. If you need 2 days’ leave, you must get leave approved with GTELinq and calendar OOP posted 2 working days prior to going on leave.</em>
//                 </li>
//               </ul>
//             </li>

//             <li>
//               Leaves must be requested, not demanded.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>9. Other leaves:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               <strong>Maternity Leave:</strong>
//               <ul style={{ paddingLeft: "20px" }}>
//                 <li>Female employees are entitled to 26 weeks of paid maternity leave.</li>
//                 <li>These leaves can be taken during the duration of your pregnancy and post childbirth.</li>
//                 <li>Employee can decide the timing of leaves that is most suitable to them.</li>
//                 <li>The leave must be taken within 1 year of the childbirth.</li>
//                 <li>The maternity leaves granted are in addition to the annual leaves that employees are entitled to.</li>
//               </ul>
//             </li>

//             <li>
//               <strong>Paternity Leave:</strong>
//               <ul style={{ paddingLeft: "20px" }}>
//                 <li>Male employees are entitled for 2 weeks of paid paternity leave.</li>
//                 <li>The leave must be taken within 1 year of the childbirth.</li>
//                 <li>The paternity leaves granted are in addition to the annual leaves that employees are entitled to.</li>
//                 <ul style={{ paddingLeft: "20px" }}>
//                   <li>These will be accounted towards the sick leave based on the available pending leaves you may have and remaining will be deducted from earned leaves.</li>
//                 </ul>
//               </ul>
//             </li>


//             <li>
//               <strong>Engagements/Weddings:</strong>
//               <ul style={{ paddingLeft: "20px" }}>
//                 <li>Employees are entitled to take 2 weeks of time off in total for the purpose of engagement/wedding.</li>
//                 <ul style={{ paddingLeft: "20px" }}>
//                   <li>Note: 2 weeks is the combined allowed maximum time off for both the events.</li>
//                 </ul>
//                 <li>The leaves granted are considered towards the annual leaves that employees are entitled to.</li>
//                 <ul style={{ paddingLeft: "20px" }}>
//                   <li>These will be accounted towards the earned leave quota.</li>
//                 </ul>
//               </ul>
//             </li>

//             <li>
//               Half day leaves are allowed. Any leaves that are requested for duration less than half day will by default be considered as half day leave request.
//             </li>
//           </ul>
//         </section>

//         <section className="policy-note-red">
//           <p><strong>10. Misuse of leaves:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Any employee found misusing the leave policy such as frequent absentees, violating break times, presenting fraudulent medical certificates, taking leaves without approval, etc., will undergo disciplinary action along with a pay cut.
//             </li>
//           </ul>
//         </section>





//         <section>
//           <p><strong>11. Punctuality:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Office timing is 3:30pm - 12:30am. In a month, you are allowed to come 10 mins late for a maximum of 2 times without any penalty.
//             </li>

//             <li>
//               If you are late more than 2 times a month, 2 days of earned leaves (EL) will be deducted.
//             </li>

//             <li>
//               When an employee does not have any EL in their bucket, 2 sick leaves will be deducted.
//             </li>
//             <li>If the employee neither has sick leave nor earned leave, it will result into penalty of 2 days pay cut.</li>
//           </ul>

//         </section>



//         <section>
//           <p style={{ marginTop: "5px" }}><strong>12. Thumb Machine Guidelines</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>You are required to punch in at the time of:</li>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//               <li>Coming to office and leaving office.</li>
//               <li>Taking your break and after coming back from break.</li>
//             </ul>
//             <li>All employees must ensure that they place the thumb properly on the device. You should see a green tick appear when you place the thumb.</li>
//             <li>In case where green tick has not appeared, please check with the Genesis IT Team.</li>
//             <li>In case an exception is granted for you to WFH, you must write an email to HR to adjust the thumb data manually by clearly mentioning the date in your email. CC your manager in that email.</li>
//           </ul>
//         </section>
//         <section>
//           <p><strong>13. Breaks:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Dinner break is 7:30pm to 8:30pm. If there is an exception meeting during this hour, you can shift your break. Inform your manager when you plan on shifting your break hour with a reason for doing so.
//             </li>

//             <li>
//               There is no 10-minute buffer for punching back in post break hour.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>14. Monitoring:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Emails will be sent to your manager and HR on a monthly basis, with you copied on the email, when punch-in and break timings are not followed punctually.
//             </li>
//           </ul>
//         </section>


//         <section>
//           <p><strong>15. Return of Original Documents:</strong></p>


//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               The company will withhold educational degree certificates, Marksheets, etc. for the period of the Employment Agreement, i.e., 2 years.
//             </li>

//             <li>
//               Employees completing their 2 years at Genesis must collect their original documents from HR.
//             </li>

//             <li>
//               At the time of document collection, HR will issue you a letter stating the return of documents submitted at the time of joining.
//             </li>
//           </ul>
//         </section>



//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           GENERAL POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },




//   {
//     id: 4,
//     title: "Out of Office (OOO) Policy",
//     icon: "🛡️",
//     content: (
//       <div className="policy-details-text">
//         <header className="policy-header-container">

//         </header>
//         <section>
//           <p><strong>Purpose:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               The Out of Office policy provides guidelines for employees to follow when they are unable to perform their duties due to absence from the workplace. This policy aims to ensure effective communication and continuity of operations during employee absences.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>Policy Overview:</strong></p>

//           <p><strong>1. Notification Requirement:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees must notify their supervisor and relevant team members of their upcoming absence at least [X days] in advance. This notice should include the start and end dates of the absence and the reason for the absence. X days – Total number of weekdays you are OOP.
//             </li>
//           </ul>

//           <p><strong>2. Penalization for Noncompliance:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees who fail to put OOP and their respective leave in the GTELINQ portal will be penalized by getting 5 business days of their respective pay deducted from their current month’s salary.
//             </li>
//           </ul>

//           <p><strong>3. Out of Office Message:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>Employees are required to set up an Out of Office email autoresponder that includes the following information:</li>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//               <li>Dates of absence (start and end)</li>
//               <li>Reason for absence (if comfortable sharing)</li>
//               <li>Alternate contact person/coverage for the duration of absence</li>
//               <li>A note that the employee will respond to emails upon return</li>
//             </ul>
//           </ul>

//           <p><strong>4. Duration of Absence:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees should specify the duration of their absence clearly. For longer absences (more than [X days]), employees are encouraged to discuss their workload and responsibilities with their supervisor beforehand.
//             </li>
//           </ul>

//           <p><strong>5. Emergency Contacts:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               If urgent matters arise during the employee's absence, the autoresponder should provide an alternative contact person who can assist in their absence.
//             </li>
//           </ul>

//           <p><strong>6. Return Notification:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees should notify their supervisor and team upon their return to the office. This ensures that everyone is aware of their availability and can resume regular communications.
//             </li>
//           </ul>

//           <p style={{ margin: "15px 0 5px 0" }}><strong>7. Documentation:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6", marginTop: "0" }}>
//             <li>
//               For planned absences (e.g., vacations, medical leaves), employees may be required to submit formal documentation (e.g. medical certificates) as per the company’s leave policy.
//             </li>
//           </ul>
//         </section>


//         <section className="policy-team-limits" style={{ marginTop: '0px' }}>
//           <strong>8. Team-Specific Absence Limits:</strong>
//           <p>The following guidelines specify the maximum number of employees allowed to be Out of Office (OOP) per team at the same time:</p>
//           <div style={{ background: 'rgba(255,255,255,0.05)', padding: '15px', borderRadius: '8px', marginTop: '10px' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
//               <thead>
//                 <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.2)', textAlign: 'left' }}>
//                   <th style={{ padding: '8px' }}>Team Name</th>
//                   <th style={{ padding: '8px' }}>Max. allowed employees on OOP</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {[
//                   ["FSP LO / FI IE", "02"],
//                   ["DDI", "01"], ["DMS", "01"], ["IQ Program", "01"],
//                   ["FI MeGA", "02"], ["FI Elec", "01"], ["FI Structural/PC", "01"],
//                   ["LTO", "01"]
//                 ].map(([team, limit], idx) => (
//                   <tr key={idx} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
//                     <td style={{ padding: '8px' }}>{team}</td>
//                     <td style={{ padding: '8px', fontWeight: 'bold', color: '#00bcd4' }}>{limit}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </section>

//         <section>
//           <p><strong>9. Responsibilities:</strong></p>

//           <p><strong>Employee:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>It is the employee's responsibility to ensure that all necessary notifications are made and that their workload is managed appropriately prior to their absence.</li>
//             <li>If OOP is not approved in the system, it is the employee’s responsibility to get it approved by reaching out to their respective managers.</li>
//             <li>Based on a first-come, first-served basis, approvals will be processed in the order requests are received.</li>
//             <li>Once your OOP is approved in the GTELinq system, ensure that you are putting your OOP in customers’ Outlook and Teams portal.</li>
//           </ul>

//           <p><strong>Supervisor/Manager:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>Supervisors are responsible for ensuring that team members understand and adhere to this policy.</li>
//             <li>They should assist in reallocating tasks if necessary to ensure continuity during absences.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>10. Coverage:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>The project on which an individual employee is working should always have coverage, and it is the employee’s responsibility to make proper arrangements.</li>
//             <li>Future project/task that is assigned to you and has not started yet should also have coverage member listed regardless of its start date being after your return.</li>
//             <li>This is because projects/tasks may get pulled in while you are on leave so we want to ensure all projects are properly resourced.</li>
//             <li>For projects that have already been completed, there should be general coverage.</li>
//           </ul>
//         </section>
//         <section >
//           <p><strong>11. Noncompliance:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Failure to adhere to the Out of Office policy may result in disciplinary actions such as unpaid leaves with deduction of an equal number of leaves from the earned leaves, as it can disrupt workflow and affect team productivity.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>12. Major medical emergencies</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>A major medical emergency is scenario which restricts you from coming to work and performing your job duties either from office or work.</li>
//             <li>This involves case when you are hospitalized.</li>
//             <li>Genesis Tech supports all their employees in times of such emergencies, and we want to make sure employees get every possible support from the team and their manager.</li>
//             <li>As you will be away from office for longer than usual duration following scenarios may apply to you on a case-by-case basis.</li>
//             <li>The number of days you are OOP will be evaluated against your pending SL and EL and will be adjusted against the pending leaves you have.</li>
//             <li>In case you do not have any leaves in the current financial year, it will result in a pay cut.</li>
//             <li>Pay deduction may happen for the number of days you were OOP without impacting your leave counts.</li>
//             <li>Your manager will discuss this with you once you are back in the office and one appropriate option from above will be applied.</li>
//           </ul>
//         </section>
//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           OUT OF OFFICE (OOO) POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },

//   {
//     id: 5,
//     title: "Public Holidays for 2026",
//     icon: "🎉",
//     content: (
//       <div className="policy-details-text">



//         <div className="okr-table-wrapper">

//           <div style={{ marginBottom: '15px', fontSize: '16px', lineHeight: '1.5' }}>
//             <p><strong>Note:</strong></p>
//             <ul style={{ paddingLeft: '20px', lineHeight: '1.5', marginTop: '5px' }}>
//               <li>Total allowable national holidays in a year are 10.</li>
//               <li>Not all festivals get their spot on the holiday calendar every year, as the number of festivals we celebrate across India is more than 10.</li>
//               <li>Overall holidays are adjusted to limit to 10, and you may see some holidays which were given in last year may not be in the list to limit the total count of national holidays to 10.</li>
//             </ul>
//           </div>

//           <table className="okr-modern-table" style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '30px' }}>
//             <thead>
//               <tr style={{ backgroundColor: '#f8f9fa' }}>
//                 <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Sr.No</th>
//                 <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Festival</th>
//                 <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Date</th>
//                 <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Day</th>
//               </tr>
//             </thead>
//             <tbody>
//               {[
//                 ["1", "New Year", "1-Jan-2026", "Thursday"],
//                 ["2", "Republic Day", "26-Jan-2026", "Monday"],
//                 ["3", "Gudi Padwa", "19-Mar-2026", "Thursday"],
//                 ["4", "Maharashtra Day", "1-May-2026", "Friday"],
//                 ["5", "Bakrid", "27-May-2026", "Wednesday"],
//                 ["6", "Ganesh Chaturthi", "14-Sep-2026", "Monday"],
//                 ["7", "Gandhi Jayanti", "2-Oct-2026", "Friday"],
//                 ["8", "Dussehra", "20-Oct-2026", "Tuesday"],
//                 ["9", "Diwali", "9-Nov-2026", "Monday"],
//                 ["10", "Christmas", "25-Dec-2026", "Friday"]
//               ].map(([sr, fest, date, day], idx) => (
//                 <tr key={idx}>
//                   <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{sr}</td>
//                   <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{fest}</td>
//                   <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{date}</td>
//                   <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{day}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           PUBLIC HOLIDAY POLICY-R00-01/MAR/2026
//         </div>

//       </div>
//     )
//   },
//   {
//     id: 6,
//     title: "Performance Of Duties",
//     icon: "⚖️",
//     content: (
//       <div className="policy-details-text">
//         <section>
//           <strong>1. Performance Of Duties</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
//             <li>The Employee agrees that during the Employment Period, he/she shall devote his/her full business time to the business affairs of the Company and shall perform the duties assigned to him/her faithfully and efficiently, and shall endeavor, to the best of his/her abilities to achieve the goals and adhere to the parameters set by the Company.</li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Responsibilities</strong>
//           <p>The Employee shall be responsible for:</p>
//           <p style={{ paddingLeft: '20px' }}>• Devoting the whole time, attention and abilities to the business of Genesis Tech Engineers unless prevented by illness.</p>
//           <p style={{ paddingLeft: '20px' }}>• Diligently perform such duties as may from time to time be assigned to you.</p>
//           <p style={{ paddingLeft: '20px' }}>• Comply with all reasonable and lawful directions given to you by Genesis Tech Engineers and your managers.</p>
//           <p style={{ paddingLeft: '20px' }}>• Act in good faith and in the best interest of Genesis Tech Engineers and its customers and staff always, including reporting your own wrongdoing and any wrongdoing of any other employee immediately on becoming aware of it.</p>
//           <p style={{ paddingLeft: '20px' }}>• Promote, Protect, Develop, and extend the business of Genesis Tech Engineers.</p>
//           <p style={{ paddingLeft: '20px' }}>• Take all reasonable steps in respect of the help and safety of yourself, colleagues, and third parties.</p>
//         </section>

//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           PERFORMANCE OF DUTIES POLICY-R00-01/MAR/2026
//         </div>

//       </div>
//     )
//   },

//   {
//     id: 7,
//     title: "Fair Compensation",
//     icon: "💰",
//     content: (

//       <div className="policy-details-text">
//         <header className="policy-header-container">

//         </header>
//         <section>
//           <p>Subject to the following provisions of this Agreement, during the Employment Period, the Employee shall be compensated for his services as follows. All compensation related activities are based on Financial Year (i.e. Apr -Mar) and not regular calendar year (Jan-Dec). </p>
//         </section>

//         <section>
//           <strong>1. Annual Salary</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
//             <li>The Employee shall receive an annual salary, payable monthly by the Employer. Subject to such increases from time to time, as determined by the Employer. Such payments shall be subject to such normal statutory deductions by the Employer.</li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Payment Method</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
//             <li>During the term of this Agreement, the Employee's salary shall be paid by means of bank transfer, cheque, or any other method convenient to the Employer, and consented to by the Employee.</li>
//           </ul>
//         </section>

//         <div>
//           <strong>3. Term insurance Policy</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
//             <li>As a part of your overall CTC package Genesis Tech will work on issuing Term insurance policy for every employee.</li>
//             <li>The term insurance policy will be issued anytime between joining to 7month service at Genesis.</li>

//             <li>
//               <strong>Policy Payments:</strong>
//               <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
//                 <li>The annual installment amount depends on multiple factors and can vary for employee to employee.</li>
//                 <li>Age, physical condition, medical test reports will define your policy premium value.</li>
//               </ul>
//             </li>

//             <li>As a part of CTC Genesis will bear certain majority portion of your policy (varies for all employees) to match your CTC and employees will be responsible to pay the excess amount.</li>
//             <li>The policy duration is 10 years.</li>
//             <li>Genesis Tech will keep on paying the annual premium amount util you are employed with Genesis Tech.</li>
//             <li>As this is administrative item, for any further questions regarding your insurance policy direct all your questions to HR. Your manager will not have details to your specific policy that applies to you.</li>
//           </ul>
//         </div>
//         <div style={{ marginTop: "25px" }}>
//           <strong>4. Annual Bonus:</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
//             <li>Annual bonus is awarded in Diwali every year.</li>
//             <li>Annual bonus are prorated based on your joining date in a financial year.</li>
//             <li>The annual bonus is awarded based on the last financial year service you performed.</li>

//             <li>
//               Examples below:
//               <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
//                 <li>If an employee joined on 1st June2025, the financial year will end on 31st March 2026 and the employee will get the annual bonus for duration of 1st June 2025 to 31st March 2026 during Diwali of 2026.</li>
//                 <li>For employees who were employed for full financial year they will get their 1st April 2025 to 31st March 2026 bonus pay in Diwali of 2026.</li>
//               </ul>
//             </li>

//           </ul>
//         </div>
//         <div style={{ marginTop: "25px" }}>
//           <strong>5. Provident Fund:</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
//             <li>Provident Fund (PF) has 2 portions employees part and employers part.</li>
//             <li>The employees part is deducted from their monthly pay and the deduction is mentioned on your pay slip.</li>
//             <li>The employer part is directly deposited into your PF account.</li>
//             <li>All employees are encouraged to have UMANG app to check your PF balance and confirm any details you might want to view regarding your PF.</li>
//           </ul>
//         </div>

//         <div style={{ marginTop: "25px" }}>
//           <strong>6. Professional Tax:</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
//             <li>Professional Tax (PT) of Rs.200/- per month is deducted from your salary.</li>
//             <li>This deduction is also listed on your payslip.</li>
//           </ul>
//         </div>


//         <section style={{ marginTop: '10px' }}>
//           <strong>7. Reimbursement Guidlines</strong>
//           <p><strong>Definition:</strong> Reimbursement is when you make an expense pre-approved by your manager on behalf of company for official purposes.</p>
//           <p>• Employees must log in to the GTELinq portal and submit the reimbursement form.</p>
//           <p>• You are required to upload all receipts for your requests.</p>
//           <p>• The receipt must be readable.</p>
//           <p>• The receipt should be in company name.</p>
//           <p>• Where GST billing can be done you should proceed with getting a GST bill.</p>
//           <p>• When asking for GST bill you must tell the seller/supplier to enter company’s full name and GST number to be included on the bill/receipt. Details are as follows:</p>
//           <div style={{ paddingLeft: '20px', margin: '10px 0' }}>
//             <strong>Name:</strong> GENESIS TECH ENGINEERS PVTD LTD.<br />
//             <strong>GST NO.:</strong> 27AAKCG7985R1ZB
//           </div>
//           <p>• The bill must be submitted in the same month within 2 days of making the transaction.</p>
//           <p>• The reimbursement will be routed to your manager for approval.</p>
//           <p>• Once manager approves the money will be deposited in the current month pay cycle.</p>
//           <p>• If the pay cycle is within 7 days of submitting the bill the payment will be released in the following pay cycle.</p>
//         </section>
//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           FAIR COMPENSATION POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },
//   {
//     id: 8,
//     title: "Obligations of the Employee",
//     icon: "📝",
//     content: (


//       <div className="policy-details-text">
//         <header className="policy-header-container">

//         </header>


//         <section>
//           <strong>1. Legal Conduct</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               Upon execution of the employment agreement, the Employee shall not engage in any sort of theft, fraud, misrepresentation, or any other illegal act neither in the employment space nor outside the premise of employment. If he/she does so, the Company shall not be liable for such acts done at his/her own risk.
//             </li>
//             <li>
//               The Employee further promises to never engage in any theft of the Employer’s property or attempt to defraud the Employer in any manner.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Compliance with Rules</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations, and policies of the Company as notified from time to time.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>3. Exclusive Service</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee shall not take up part-time or full-time employment or consultation with any other party or be involved in any other business during the term of his/her employment with the Company.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>4. Return of Property</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               On termination, the Employee shall immediately return to the Employer all documents, books, materials, records, correspondence, papers and information (on whatever media and wherever located) relating to the Employer’s business or affairs, or relating to the Employer’s business contacts, any keys, credit cards, access cards, and any other property of the Employer, which is in the Employee’s possession or under the Employee’s control.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>5. Specific Policies</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations, and policies of the Company as notified from time to time, including but not limited to the Leave Policy and Sexual Harassment Policy.
//             </li>
//             <li>
//               The Employer prohibits the Employee from engaging in any form of sexual harassment and the Employee promises to refrain from any form of sexual harassment during employment in and around the premises of employment. If the Employee violates this term in the agreement, he/she shall be fully responsible for his/her actions, and the Employer shall not be held responsible for any illegal acts committed at the discretion of the Employee.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>6. Dress Code</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>Monday of every week is formal wear day.</li>
//             <li>Other days in the week are casual wears suitable for the office environment.</li>
//           </ul>
//         </section>

//         <section>
//           <strong>7. Use of common areas in building premises and offices:</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>Common building spaces must be used hygienically.</li>
//             <li>Everyone using the space must ensure they are not causing spills and keep the place clean.</li>
//           </ul>
//         </section>

//         <section>
//           <strong>8. ID Cards:</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>ID cards are compulsory in the office. You must wear them at all times while on the building campus.</li>
//           </ul>
//         </section>
//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           OBLIGATION OF THE EMPLOYEE POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },
//   {
//     id: 9,
//     title: "Assignments",
//     icon: "📋",
//     content: (
//       <div className="policy-details-text">
//         <header className="policy-header-container">
//           {/* <h2 className="policy-main-title">Assignment</h2> */}
//         </header>

//         <section>
//           <strong>1. Works Made for Hire</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee acknowledges that any work including, without limitation, inventions, designs, ideas, concepts, drawings, working notes, artistic works that the Employee may individually or jointly conceive or develop during the term of Employment are “works made for hire.”
//             </li>
//             <li>
//               To the fullest extent permitted by law, the Employee shall assign, and does hereby assign, to the Employer all of the Employee's right, title, and interest in and to all Intellectual Property improved, developed, discovered, or written in such works.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Documentation and Vesting</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee shall, upon request of the Employer, execute, acknowledge, deliver, and file any and all documents necessary or useful to vest in the Employer all of the Employee's right, title, and interest in and to all such matters.
//             </li>
//           </ul>
//         </section>
//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           ASSIGNMENTS POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },
//   {
//     id: 10,
//     title: "Confidentiality",
//     icon: "🔒",
//     content: (
//       <div className="policy-details-text">
//         <header className="policy-header-container"></header>

//         <section>
//           <strong>1. Access to Information</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee acknowledges that, while performing and fulfilling his/her duties hereunder, he/she may have access to and be entrusted with confidential information concerning the present and contemplated financial status and activities of the Employer.
//             </li>
//             <li>
//               The disclosure of any of this confidential information to competitors of the Employer would be highly detrimental to the interests of the Employer.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Proprietary Rights</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee further acknowledges and agrees that the right to maintain the confidentiality of trade secrets, source code, website information, business plans, client information, or other confidential or proprietary information constitutes a proprietary right.
//             </li>
//             <li>
//               The Employer is entitled to protect this proprietary right.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>3. Non-Disclosure Covenant</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee covenants and agrees that he/she will not, under any circumstance during the continuance of this agreement, disclose any such confidential information to any person, firm, or corporation.
//             </li>
//             <li>
//               The Employee shall not use the confidential information except as required in the normal course of engagement.
//             </li>
//             <li>
//               Even after termination of employment, the Employee shall not disclose or make use of the confidential information, nor cause it to be disclosed in any manner.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>4. Intellectual Property Ownership</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employer owns any intellectual property created by the Employee during employment, or in relation to a certain field, and has all necessary rights to retain it.
//             </li>
//             <li>
//               After termination of employment, the Employee shall not claim any rights on the intellectual property created.
//             </li>
//             <li>
//               Any source code, software, or other intellectual property developed, including website design or functionality created by the Employee during employment under this Agreement, shall belong to the Employer.
//             </li>
//           </ul>
//         </section>

//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           CONFIDENTIALITY POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },



//   {
//     id: 11,
//     title: "Employee Termination",
//     icon: "🚫",
//     content: (
//       <div className="policy-details-text">
//         <header className="policy-header-container"></header>

//         <section>
//           <strong>1. Employer Termination</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>The Employer may terminate your employment without any notice.</li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Employee Resignation</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>The Employee may terminate his/her employment by providing the Employer with at least 2-month(s) advance notice of his/her intention to resign.</li>
//           </ul>
//         </section>


//         <section>
//           <strong>3. Notice Period</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               For employees wishing to terminate their employment with Genesis Tech will be considered to opt for one of the two options listed below:
//               <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//                 <li>Immediate termination (0 Day notice period served)</li>
//                 <li>Full notice period served (60 Day notice period served)</li>
//               </ul>
//               Based on option that employee chooses the following process will be applicable to complete employees exit procedures.
//             </li>
//           </ul>
//         </section>


//         <section>
//           <strong>4. Exit Procedure Policy</strong>
//           <div style={{ marginTop: '20px' }}>
//             <strong>Case 1:</strong>

//             <p style={{ marginTop: '10px' }}>
//               A clean exit procedure at GTE is meeting the following 2 criteria listed-
//             </p>

//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>Service Agreement Duration: 2 years</li>
//               <li>Notice period: 2 months post completion of service agreement.</li>
//             </ul>

//             <p style={{ marginTop: '10px' }}>
//               If the above criteria is met, the process will occur in following sequence-
//             </p>

//             <p style={{ marginTop: '15px' }}><strong>Documentation</strong></p>
//             <p style={{ marginTop: '5px' }}>
//               GTE will provide you with following documentation as a part of exit procedures-
//             </p>
//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>Relieving Letter</li>
//               <li>Experience Letter</li>
//               <li>Payslip of last month of service at GTE</li>
//               <li>Handover of any original documents submitted</li>
//               <li>Signing of form stating receipt of original documents (A copy will be provided to employee)</li>
//             </ul>

//             <p style={{ marginTop: '15px' }}><strong>Finances</strong></p>
//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>Pay for last month of employment at GTE.</li>
//               <li>Payment of earned leaves accumulated while being at GTE.</li>
//             </ul>

//             <p style={{ marginTop: '15px' }}>
//               The documentation and financial settlement will take place within 2 business days.
//             </p>
//           </div>

//           <section>
//             <strong>Notice Period Violation:</strong>
//             <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//               <li>
//                 In the event where notice period could not be served by the employee, they must discuss with their manager a plan of exiting immediately by paying 2 months of your pay for notice period duration. Once the payment is made you will be entitled to receive the following documents:
//                 <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//                   <li>Relieving Letter</li>
//                   <li>Experience Letter</li>
//                   <li>Return of original documents submitted at the time of joining</li>
//                   <li>Pay and Payslip of your last month of service at GTE</li>
//                 </ul>
//               </li>


//             </ul>
//           </section>

//           <div style={{ marginTop: '20px' }}>
//             <strong>Case 2:</strong>

//             <p style={{ marginTop: '10px' }}>Any duration which is less than 2 years of service agreement.</p>

//             <p style={{ marginTop: '10px' }}>
//               In event when you choose to leave prior to end of your service agreement duration, you are required to complete the 2 months’ notice period as a mandatory requirement.
//             </p>

//             <p style={{ marginTop: '10px' }}>The process will occur in following sequence-</p>

//             <p style={{ marginTop: '15px' }}><strong>Finances</strong></p>
//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>GTE will recover the cost for time invested in training.</li>
//               <li>This is 6 months of your pay (your probation duration).</li>
//               <li>GTE will send pending dues notice for the same.</li>
//             </ul>

//             <p style={{ marginTop: '15px' }}>Until the above criteria is satisfied all the items below will be withheld.</p>
//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>Pay for last month of employment.</li>
//               <li>Payment of earned leaves accumulated.</li>
//             </ul>

//             <p style={{ marginTop: '15px' }}>
//               The above payments will be used against your financial dues and the financial dues notice will include all the respective details.
//             </p>

//             <p style={{ marginTop: '15px' }}><strong>Documentation on hold</strong></p>
//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>Relieving Letter</li>
//               <li>Experience Letter</li>
//               <li>Return of original documents submitted at the time of joining.</li>
//               <li>Payslip of last month of service at GTE</li>
//             </ul>


//             <section>
//               <strong>Notice Period Violation:</strong>
//               <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>

//                 <li>
//                   You are liable to follow the requirements mentioned under the section “Case 2” along with additional payment of 2 months of notice period to be considered for a complete exit procedure.
//                 </li>
//                 <li>GTE will not allow you to serve partial duration of notice period.</li>
//               </ul>
//             </section>
//           </div>

//           <div style={{ marginTop: '15px', paddingTop: '15px' }}>
//             <p><strong>5. In the event where any of the above conditions are not met the employee is not entitled to receive:</strong></p>
//             <ul style={{ paddingLeft: '20px' }}>
//               <li>Relieving Letter.</li>
//               <li>Experience Letter.</li>
//               <li>Return of original documents submitted at the time of joining.</li>
//               <li>Pay and Payslip of your last month of service at GTE.</li>
//             </ul>
//           </div>

//           <div style={{ marginTop: '15px' }}>
//             <p><strong>6. Employee Responsibility:</strong></p>
//             <ul style={{ paddingLeft: '20px' }}>
//               <li>Schedule a 1:1 with your manager and discuss your departure plan.</li>
//               <li>Send official email of resignation to hr@genesistech.co.in with your manager copied on the email.</li>
//               <li>Make sure all office belongings are returned back to your manager. This includes your laptop, charger, headset, notebooks, notes in any form etc.</li>
//             </ul>
//           </div>

//           <div style={{ marginTop: '15px' }}>
//             <p><strong>7. Manager’s responsibilities:</strong></p>
//             <ul style={{ paddingLeft: '20px' }}>
//               <li>Ensure all the above things are met in order for successful completion of employee relieving process.</li>
//             </ul>
//           </div>
//         </section>



//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           EMPLOYEE TERMINATION POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   }


// ];

// const CompanyPolicy = ({ userData }) => {
//   const [companyLogo, setCompanyLogo] = useState("");
//   const [selectedPolicy, setSelectedPolicy] = useState(null);
//   const [logs, setLogs] = useState({});
//   const [loading, setLoading] = useState(false);

//   const empBadgeId = userData?.EmpId || userData?.employeeId;
//   const fullName = `${userData?.FirstName || ''} ${userData?.LastName || ''}`.trim();
//   const API_URL = "/gt-api/acknowledgepolicy.php";

//   useEffect(() => {
//     const fetchMyLogs = async () => {
//       if (!empBadgeId) return;

//       try {
//         const response = await fetch(`${API_URL}?empId=${empBadgeId}`);
//         const result = await response.json();

//         const logsArray = result.logs || [];

//         const signedMap = logsArray.reduce((acc, curr) => {
//           if (curr.policy_title) {
//             acc[curr.policy_title] = true;
//           }
//           return acc;
//         }, {});

//         setLogs(signedMap);

//       } catch (e) {
//         console.error("Failed to load policy signatures:", e);
//       }
//     };

//     fetchMyLogs();
//   }, [empBadgeId]);

//   const handleReadStatus = async (policyTitle) => {
//     if (!empBadgeId) {
//       alert("User Session Missing: EmpId not found. Please log out and back in.");
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await fetch(API_URL, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           empId: empBadgeId,
//           fullName: fullName,
//           policyTitle: policyTitle
//         }),
//       });
//       const result = await response.json();
//       if (result.status === "success") {
//         setLogs(prev => ({ ...prev, [policyTitle]: true }));
//       } else {
//         alert("Server Error: " + (result.message || "Could not save."));
//       }
//     } catch (error) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const isRead = (title) => logs[title] || false;

//   const [companyPolicies, setCompanyPolicies] = useState([]);
//   const isGenesis =
//     userData?.EmailId?.toLowerCase().includes("genesistech.co.in") ||
//     userData?.EmailId?.toLowerCase().includes("gtecorpgroup.com") ||
//     userData?.EmailId?.toLowerCase().includes("gtcorpgroup.com");
//   useEffect(() => {
//     if (isGenesis) return;

//     fetch(
//       "/gt-api/get_policies.php",
//       {
//         credentials: "include"
//       }
//     )
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) {
//           setCompanyPolicies(data.policies || []);
//         }
//       });
//   }, [isGenesis]);

//   useEffect(() => {
//     const email = userData?.EmailId || "";
//     const domain = email.split("@")[1]?.toLowerCase();
//     if (!domain) return;

//     fetch(
//       "/gt-api/get_company_logo.php",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({ domain })
//       }
//     )
//       .then(res => res.json())
//       .then(data => {
//         if (data.success && data.company_logo) {
//           setCompanyLogo(
//             `/gt-api/${data.company_logo}`
//           );
//         }
//       })
//       .catch(console.error);
//   }, [userData]);

//   const policies = isGenesis
//     ? GENESIS_POLICIES
//     : companyPolicies;

//   return (
//     <div className="policy-wrapper">

//       {/* ================= DESKTOP VIEW ================= */}
//       <div className="desktop-policy-layout">

//         {/* Sidebar */}
//         <div className="policy-sidebar-nav glass">
//           <div className="sidebar-header"></div>

//           <div className="policy-menu">
//             {policies.map((p) => (
//               <div
//                 key={p.id}
//                 className={`policy-item ${selectedPolicy?.id === p.id ? "active" : ""
//                   }`}
//                 onClick={() => setSelectedPolicy(p)}
//               >
//                 <div className="active-indicator"></div>

//                 <span className="p-icon">
//                   {isGenesis ? p.icon : p.policy_icon}
//                 </span>

//                 <span className="p-text">
//                   {isGenesis ? p.title : p.policy_title}
//                 </span>

//                 {isRead(
//                   isGenesis ? p.title : p.policy_title
//                 ) && <span className="p-status-check">✅</span>}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Viewer */}
//         <div className="policy-viewer glass">
//           {selectedPolicy ? (
//             <div className="viewer-content animate-fade">

//               <div className="viewer-header">
//                 <div className="header-info">
//                   <h1>
//                     {isGenesis
//                       ? selectedPolicy.title
//                       : selectedPolicy.policy_title}
//                   </h1>
//                 </div>
//               </div>

//               <div className="cyber-divider"></div>

//               <div className="document-body">
//                 <section className="doc-section">

//                   {isGenesis ? (
//                     selectedPolicy.content
//                   ) : (
//                     <div
//                       style={{ lineHeight: "1.9" }}
//                       dangerouslySetInnerHTML={{
//                         __html: selectedPolicy.policy_content
//                           .split("\n")
//                           .map((line) => {
//                             const trimmed = line.trim();

//                             if (!trimmed) return "<br>";

//                             if (/^\d+\./.test(trimmed)) {
//                               return `<br><strong>${trimmed}</strong><br>`;
//                             }

//                             return `• ${trimmed}<br>`;
//                           })
//                           .join("")
//                       }}
//                     />
//                   )}

//                 </section>

//                 <div
//                   className="acknowledgement-section"
//                   style={{
//                     marginTop: "40px",
//                     padding: "20px",
//                     backgroundColor: "rgba(255,255,255,0.05)",
//                     borderRadius: "8px",
//                     textAlign: "center"
//                   }}
//                 >
//                   <button
//                     className={`read-button ${isRead(
//                       isGenesis
//                         ? selectedPolicy.title
//                         : selectedPolicy.policy_title
//                     )
//                       ? "disabled"
//                       : ""
//                       }`}
//                     onClick={() =>
//                       handleReadStatus(
//                         isGenesis
//                           ? selectedPolicy.title
//                           : selectedPolicy.policy_title
//                       )
//                     }
//                     disabled={isRead(
//                       isGenesis
//                         ? selectedPolicy.title
//                         : selectedPolicy.policy_title
//                     )}
//                   >
//                     {isRead(
//                       isGenesis
//                         ? selectedPolicy.title
//                         : selectedPolicy.policy_title
//                     )
//                       ? "✓ Policy Acknowledged"
//                       : "Read and Understood"}
//                   </button>
//                 </div>
//               </div>

//               <div className="policy-footer">
//                 {/* <p>© Genesis Tech Engineers Pvt. Ltd.</p> */}
//               </div>

//             </div>
//           ) : (
//             <div className="empty-policy-wrapper">
//               <div className="empty-policy-state">
//                 <img
//                   src={companyLogo || logoWhite}
//                   alt="Company Logo"
//                   style={{
//                     width: "350px",
//                     height: "auto",
//                     marginBottom: "80px"
//                   }}
//                 />

//                 <p className="empty-policy-text">
//                   PICK A POLICY FROM THE SIDEBAR TO READ IT.
//                 </p>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ================= MOBILE VIEW ================= */}

//       {!selectedPolicy ? (
//         <div className="mobile-policy-list">

//           {policies.map((p) => (
//             <div
//               key={p.id}
//               className="mobile-policy-card"
//               onClick={() => setSelectedPolicy(p)}
//             >
//               <div className="mobile-policy-header">

//                 <span className="mobile-policy-icon">
//                   {isGenesis ? p.icon : p.policy_icon}
//                 </span>

//                 <span className="mobile-policy-title">
//                   {isGenesis ? p.title : p.policy_title}
//                 </span>

//               </div>

//               {isRead(
//                 isGenesis ? p.title : p.policy_title
//               ) && (
//                   <div className="mobile-policy-status">
//                     ✅ Acknowledged
//                   </div>
//                 )}
//             </div>
//           ))}

//         </div>
//       ) : (
//         <div className="mobile-policy-viewer">

//           <button
//             className="mobile-policy-back-btn"
//             onClick={() => setSelectedPolicy(null)}
//           >
//             ← BACK TO POLICIES
//           </button>

//           <h2 className="mobile-policy-heading">
//             {isGenesis
//               ? selectedPolicy.title
//               : selectedPolicy.policy_title}
//           </h2>

//           <div className="mobile-policy-content">

//             {isGenesis ? (
//               selectedPolicy.content
//             ) : (
//               <div
//                 style={{ lineHeight: "1.9" }}
//                 dangerouslySetInnerHTML={{
//                   __html: selectedPolicy.policy_content
//                     .split("\n")
//                     .map((line) => {
//                       const trimmed = line.trim();

//                       if (!trimmed) return "<br>";

//                       if (/^\d+\./.test(trimmed)) {
//                         return `<br><strong>${trimmed}</strong><br>`;
//                       }

//                       return `• ${trimmed}<br>`;
//                     })
//                     .join("")
//                 }}
//               />
//             )}

//           </div>

//           <div className="acknowledgement-section mobile-ack">

//             <button
//               className={`read-button ${isRead(
//                 isGenesis
//                   ? selectedPolicy.title
//                   : selectedPolicy.policy_title
//               )
//                 ? "disabled"
//                 : ""
//                 }`}
//               onClick={() =>
//                 handleReadStatus(
//                   isGenesis
//                     ? selectedPolicy.title
//                     : selectedPolicy.policy_title
//                 )
//               }
//               disabled={isRead(
//                 isGenesis
//                   ? selectedPolicy.title
//                   : selectedPolicy.policy_title
//               )}
//             >
//               {isRead(
//                 isGenesis
//                   ? selectedPolicy.title
//                   : selectedPolicy.policy_title
//               )
//                 ? "✓ Policy Acknowledged"
//                 : "Read and Understood"}
//             </button>

//           </div>

//         </div>
//       )}

//     </div>
//   );
// };

// export default CompanyPolicy;










































// import React, { useState, useEffect } from 'react';
// import '../styles/CompanyPolicy.css';
// import logoWhite from '../assets/logowhite.png';

// export const GENESIS_POLICIES = [
//   {
//     id: 1,
//     title: "Probation Policy",
//     icon: "⏳",
//     content: (

//       <div className="policy-details-text">
//         <header className="policy-header-container">

//         </header>
//         <section>
//           <p><strong>1. Purpose & Scope</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               The purpose of this policy is to define the terms and conditions applicable during the six-month probationary period for new employees at Genesis Tech Engineers Pvt. Ltd. This period is intended to evaluate the employee’s performance, compatibility with company culture, and overall suitability for the role. This policy applies to all newly hired employees who are undergoing their initial six-month probationary period at Genesis Tech Engineers Pvt. Ltd.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>2. Duration and Assessment</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>All new employees must undergo a probationary period lasting six (6) months from their official start date. The probationary period is designed to assess the employee’s performance and fit within the company.</li>

//             <li>Your manager at the end of your 6 month probation period may decide to extend your probation period for 3 additional months. This is so that your manager still believes in your abilities and that your performance will meet the requirements of clearing the probation period.</li>

//             <li>There is only one time extension to probation duration.</li>

//             <li>Manager will submit a performance review at the end of your probation period to HR.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>3. Leave Entitlements & Penalties</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>During the probationary period, employees are not entitled to any leaves. Only emergency case leaves will be approved and will be counted towards the earned leave.</li>

//             <li>If leaves are taken the penalty will be +1 or +2 additional leaves deducted from your earned leave based on scenarios mentioned below.</li>

//             <li>If employee takes below or up to 2 days leave during probation, then +1 rule will apply i.e. 1 additional earned leave will deducted.</li>

//             <li>If an employee takes leave for more than 2 days during probation then +2 rule will apply i.e additional 2 days of earned leave will be deducted from the overall leaves they applied.</li>
//           </ul>
//         </section>
//         <section>
//           <p><strong>4. Performance Review & Confirmation</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Performance evaluations will be conducted periodically throughout the probationary period to assess the employee’s performance, adherence to company policies, and overall suitability for the position. A formal review will occur at the end of the probationary period to determine whether the employee will be confirmed as a permanent staff member.
//             </li>
//           </ul>
//         </section>

//         <section className="policy-note-red">
//           <p><strong>5. Termination</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employment may be terminated at any time during the probationary period, with or without notice, if the employee’s performance or conduct does not meet the standards set by Genesis Tech Engineers Pvt. Ltd. The standard notice period, as outlined in the employment contract, will apply unless otherwise specified.
//             </li>
//           </ul>
//         </section>
//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           PROBATION POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },
//   {
//     id: 2,
//     title: "WFH Policy",
//     icon: "🏠",
//     content: (
//       <div className="policy-details-text">
//         <section style={{ marginBottom: '20px' }}>
//           <p><strong>1. Purpose:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               The Work from Home (WFH) option is provided as an additional benefit to support employees in extreme case of emergency, a personal obligation that may prevent office attendance. This allows employees to work from a location other than the office on a limited basis, as long as they can effectively fulfill their responsibilities without disrupting daily operations or team productivity. At Genesis Tech we do not entertain any WFH request unless the reason is compelling. The reason should be fully disclosed and explained to manager in order for the request to be considered with an awareness of high chances of the request getting denied.
//             </li>
//           </ul>
//         </section>
//       <section style={{ marginBottom: "15px" }}>
//   <p><strong>Annual WFH Allocation:</strong></p>

//   <ul
//     style={{
//       paddingLeft: "20px",
//       marginTop: "0px",
//       lineHeight: "1.6",
//     }}
//   >
//     <li>WFH is not allowed during probation phase of your employment.</li>

//     <li>
//       The allowance is <span className="wfh-span-bold">12 WFH days per calendar year.</span>
//     </li>

//     <li>
//       Unused WFH days <span className="wfh-span-bold">will not carry forward</span> to the following
//       calendar year.
//     </li>

//     <li>
//       Employees are responsible for keeping track of their remaining WFH quota.
//     </li>

//     <li>
//       WFH requests should be submitted in advance through the normal
//       leave/WFH application process in GTELinq.
//     </li>

//     <li>
//       Once an employee has used all 12 WFH days,{" "}
//       <span className="wfh-span-bold">
//         no additional WFH days will be granted during that calendar year.
//       </span>
//     </li>

//     <li>
//       WFH is a flexibility provided by the Company and should not impact
//       productivity, deliverables, availability, communication or customer
//       commitments.
//     </li>

//     <li>
//       Employees are expected to maintain the same level of professionalism,
//       responsiveness, working hours, and performance while working remotely as
//       they would from the office.
//     </li>
//   </ul>
// </section>

//         <section style={{ marginBottom: '15px' }}>
//           <strong>2. Request Process:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>WFH requests should be submitted to the manager by writing an email at least 2 days in advance describing the detailed reason for request.</li>
//             <li>If the manager does not respond to your email by the date of when you want to start your WFH you must consider that the request is rejected.</li>
//             <li>Requesting WFH that does not fit the 2 day request window will be denied regardless of the reason.</li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <p><strong>3. Work Hours:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees must adhere to their regular work hours while working from home. Availability during working hours is mandatory.
//             </li>
//           </ul>
//         </section>
//         <section style={{ marginBottom: '15px' }}>
//           <strong>4. Communication:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Employees must remain reachable via email, phone, and messaging platforms throughout the WFH day.</li>
//             <li>Regular checking and status updates should be maintained with the team.</li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <strong>5. Workspace Requirements:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Employees must ensure a suitable and productive workspace at home, free from distractions.</li>
//             <li>Reliable internet access is mandatory to maintain connectivity and productivity.</li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <strong>6. Security and Compliance:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Employees must adhere to all company data security policies while working from home.</li>
//             <li>Confidential company information must be handled with the same level of security as in the office.</li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <strong>7. Performance Expectations:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Approved WFH must not result in you loosing your job due to lack of performance. No future WFH will be granted to such individuals.</li>
//             <li>Employees are expected to maintain the same level of productivity and performance while working from home.</li>
//             <li>Deliverables and deadlines remain unchanged unless otherwise communicated.</li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <p><strong>8. Technology and Equipment:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees are responsible for ensuring their home office setup (computer, software, internet) is adequate for work tasks.
//             </li>
//           </ul>
//         </section>

//         <section style={{ marginBottom: '15px' }}>
//           <strong>9. Reporting:</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Employees must report their daily activities and tasks completed in their respective work log tracker at the end of each WFH day.</li>
//             <li>Any issues or challenges encountered should be communicated promptly.</li>
//           </ul>
//         </section>


//         <section style={{ marginBottom: '15px' }}>
//           <strong>10.Wedding :</strong>
//           <ul style={{ paddingLeft: '20px' }}>
//             <li>Employees are entitled to take maximum 1 week of WFH for the purpose of wedding.</li>

//           </ul>
//         </section>


//         <section style={{ marginTop: '20px', padding: '15px', border: '1px solid #ff4444', borderRadius: '8px', background: 'rgba(255, 68, 68, 0.05)' }}>
//           <strong>11. Exceptions:</strong>
//           <p>Exceptions: There are no exceptions to this WFH policy. WFH is very difficult request to be approved. A strong reason which your manager can agree to is mandatory.</p>
//         </section>

//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           WFH POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },
//   {
//     id: 3,
//     title: "General Policy",
//     icon: "📅",
//     content: (
//       <div className="policy-details-text">
//         <header className="policy-header-container">

//         </header>
//         <section>
//           <strong>1. Leave Entitlements</strong>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>The employee is entitled to take 12 days of paid sick leaves (SL) in a year, 11 days of earned leaves (EL) in a year which is earned in proportion to total months of service has been completed.</li>
//             <li>The Sick Leave (SL) and Earned Leave (EL) will be prorated based on your joining date. E.g. If your joining date is 13th June, your account will show 10 days of SL available for that financial year and accordingly EL will be accumulated with every month of your service at Genesis except for the month of March.</li>
//             <li>Employees will be entitled to 10 public holidays mentioned under the leave policy every financial year</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>2. Carry Forward Rules</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>Other than the earned leaves, the employee cannot carry forward any leaves to next year.</li>

//             <li>Genesis Tech will encash the total available earned leaves at the time of leaving the company.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>3. Encashment Limit</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>Maximum number of earned leaves that can be carried forward over the period of service is 45 days.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>4. Consecutive leaves:</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>Maximum number of leaves that can be taken together in one slot – 1wk (5 business days)</li>

//             <li>Consecutive leaves beyond 2 days must be applied as earned leave.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>5. Leave quota:</strong></p>
//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>Any leaves taken beyond your allocated leave balance will be considered unpaid and will result in pay deduction.</li>

//             <li>Earned leaves are earned 1 per month of service completed except in the month of March.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>6. Sick Leaves</strong></p>

//           <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
//             <li>
//               Sick leaves up to 2 days do not require any medical certificate/documentation to be provided and can be applied as sick leave.
//             </li>

//             <li>
//               Medical leaves greater than 2 days consecutively will mandatorily require medical documentation to be submitted for it to be considered as sick leave. Medical leaves greater than 2 days may fall into one of the following two categories-

//               <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>

//                 <li>
//                   <strong>Pre-planned medical leave</strong>

//                   <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
//                     <li>This includes any planned medical appointments that you are already aware of or any medical emergency you face.</li>
//                     <li>Employees must submit the medical certificate/prescription note latest within 2 days of returning from leave for the leave to be considered as sick leave.</li>
//                     <li>Process to apply:

//                       <ul style={{ listStyleType: "square", paddingLeft: "20px" }}>
//                         <li>Apply for sick leave in the system before going on leave.</li>
//                         <li>It will auto change to Earned Leave upon submission.</li>
//                         <li>Once you come back from leave you have 2 days to submit the medical documentation proof.</li>
//                         <li>You will have to log in back to the system and upload the documentation.</li>
//                         <li>Notification will go to the manager and once they accept the proof your leave will be converted from earned leave to sick leave.</li>
//                         <li>Failure to submit medical documentation within 2 days of return will result in the leave to be considered as earned leave.</li>
//                       </ul>

//                     </li>
//                   </ul>
//                 </li>

//                 <li>
//                   <strong>Non-pre-planned medical leaves:</strong>

//                   <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
//                     <li>You are not expected to apply for these leaves before going on leave as this is scenario of emergency and we are aware you may not have laptop access.</li>
//                     <li>Process to apply:

//                       <ul style={{ listStyleType: "square", paddingLeft: "20px" }}>
//                         <li>This is backdated leave.</li>
//                         <li>Apply for sick leave in the system within 2 days of rejoining the work.</li>
//                         <li>As this is post the medical event we expect you to have medical documentation proof ready before you apply.</li>
//                         <li>At the time of application, you must upload the medical documentation proof.</li>
//                         <li>Failure to do so will change the leave to a earned leave category.</li>
//                       </ul>

//                     </li>
//                   </ul>
//                 </li>

//                 <li>
//                   <strong>Note:</strong> Notification will go to the manager and once they accept the proof your leave will be converted from earned leave to sick leave.
//                 </li>

//               </ul>
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>7. Professionalism and respecting others personal time:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Stop sending messages on weekends:
//               <ol style={{ paddingLeft: "20px", marginTop: "6px" }}>
//                 <li>Asking for leave on Monday.</li>
//                 <li>Being delayed to office on any workday particularly Monday.</li>
//               </ol>
//             </li>

//             <li>
//               If it is extremely urgent call your manager.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>8. Leave requests and documentation:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employee must request leave through GTELinq and add notification to customers calendar and messaging portals like teams and outlook upon leave being approved and prior to going on OOP.
//               <ul style={{ paddingLeft: "20px", marginTop: "6px" }}>
//                 <li>
//                   <em>e.g. If you need 2 days’ leave, you must get leave approved with GTELinq and calendar OOP posted 2 working days prior to going on leave.</em>
//                 </li>
//               </ul>
//             </li>

//             <li>
//               Leaves must be requested, not demanded.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>9. Other leaves:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               <strong>Maternity Leave:</strong>
//               <ul style={{ paddingLeft: "20px" }}>
//                 <li>Female employees are entitled to 26 weeks of paid maternity leave.</li>
//                 <li>These leaves can be taken during the duration of your pregnancy and post childbirth.</li>
//                 <li>Employee can decide the timing of leaves that is most suitable to them.</li>
//                 <li>The leave must be taken within 1 year of the childbirth.</li>
//                 <li>The maternity leaves granted are in addition to the annual leaves that employees are entitled to.</li>
//               </ul>
//             </li>

//             <li>
//               <strong>Paternity Leave:</strong>
//               <ul style={{ paddingLeft: "20px" }}>
//                 <li>Male employees are entitled for 2 weeks of paid paternity leave.</li>
//                 <li>The leave must be taken within 1 year of the childbirth.</li>
//                 <li>The paternity leaves granted are in addition to the annual leaves that employees are entitled to.</li>
//                 <ul style={{ paddingLeft: "20px" }}>
//                   <li>These will be accounted towards the sick leave based on the available pending leaves you may have and remaining will be deducted from earned leaves.</li>
//                 </ul>
//               </ul>
//             </li>


//             <li>
//               <strong>Engagements/Weddings:</strong>
//               <ul style={{ paddingLeft: "20px" }}>
//                 <li>Employees are entitled to take 2 weeks of time off in total for the purpose of engagement/wedding.</li>
//                 <ul style={{ paddingLeft: "20px" }}>
//                   <li>Note: 2 weeks is the combined allowed maximum time off for both the events.</li>
//                 </ul>
//                 <li>The leaves granted are considered towards the annual leaves that employees are entitled to.</li>
//                 <ul style={{ paddingLeft: "20px" }}>
//                   <li>These will be accounted towards the earned leave quota.</li>
//                 </ul>
//               </ul>
//             </li>

//             <li>
//               Half day leaves are allowed. Any leaves that are requested for duration less than half day will by default be considered as half day leave request.
//             </li>
//           </ul>
//         </section>

//         <section className="policy-note-red">
//           <p><strong>10. Misuse of leaves:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Any employee found misusing the leave policy such as frequent absentees, violating break times, presenting fraudulent medical certificates, taking leaves without approval, etc., will undergo disciplinary action along with a pay cut.
//             </li>
//           </ul>
//         </section>





//         <section>
//           <p><strong>11. Punctuality:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Office timing is 3:30pm - 12:30am. In a month, you are allowed to come 10 mins late for a maximum of 2 times without any penalty.
//             </li>

//             <li>
//               If you are late more than 2 times a month, 2 days of earned leaves (EL) will be deducted.
//             </li>

//             <li>
//               When an employee does not have any EL in their bucket, 2 sick leaves will be deducted.
//             </li>
//             <li>If the employee neither has sick leave nor earned leave, it will result into penalty of 2 days pay cut.</li>
//           </ul>

//         </section>



//         <section>
//           <p style={{ marginTop: "5px" }}><strong>12. Thumb Machine Guidelines</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>You are required to punch in at the time of:</li>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//               <li>Coming to office and leaving office.</li>
//               <li>Taking your break and after coming back from break.</li>
//             </ul>
//             <li>All employees must ensure that they place the thumb properly on the device. You should see a green tick appear when you place the thumb.</li>
//             <li>In case where green tick has not appeared, please check with the Genesis IT Team.</li>
//             <li>In case an exception is granted for you to WFH, you must write an email to HR to adjust the thumb data manually by clearly mentioning the date in your email. CC your manager in that email.</li>
//           </ul>
//         </section>
//         <section>
//           <p><strong>13. Breaks:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Dinner break is 7:30pm to 8:30pm. If there is an exception meeting during this hour, you can shift your break. Inform your manager when you plan on shifting your break hour with a reason for doing so.
//             </li>

//             <li>
//               There is no 10-minute buffer for punching back in post break hour.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>14. Monitoring:</strong></p>

//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Emails will be sent to your manager and HR on a monthly basis, with you copied on the email, when punch-in and break timings are not followed punctually.
//             </li>
//           </ul>
//         </section>


//         <section>
//           <p><strong>15. Return of Original Documents:</strong></p>


//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               The company will withhold educational degree certificates, Marksheets, etc. for the period of the Employment Agreement, i.e., 2 years.
//             </li>

//             <li>
//               Employees completing their 2 years at Genesis must collect their original documents from HR.
//             </li>

//             <li>
//               At the time of document collection, HR will issue you a letter stating the return of documents submitted at the time of joining.
//             </li>
//           </ul>
//         </section>



//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           GENERAL POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },




//   {
//     id: 4,
//     title: "Out of Office (OOO) Policy",
//     icon: "🛡️",
//     content: (
//       <div className="policy-details-text">
//         <header className="policy-header-container">

//         </header>
//         <section>
//           <p><strong>Purpose:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               The Out of Office policy provides guidelines for employees to follow when they are unable to perform their duties due to absence from the workplace. This policy aims to ensure effective communication and continuity of operations during employee absences.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>Policy Overview:</strong></p>

//           <p><strong>1. Notification Requirement:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees must notify their supervisor and relevant team members of their upcoming absence at least [X days] in advance. This notice should include the start and end dates of the absence and the reason for the absence. X days – Total number of weekdays you are OOP.
//             </li>
//           </ul>

//           <p><strong>2. Penalization for Noncompliance:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees who fail to put OOP and their respective leave in the GTELINQ
//               portal will be penalized by deducting N+1 days of leave from their earned
//               leave account (N indicates the number of days they are OOP).
//             </li>

//             <li>
//               Example: If an employee missed adding leaves for 1 day,
//               1 + 1 = 2 Earned Leaves will be deducted from their account.
//             </li>
//           </ul>

//           <p><strong>3. Out of Office Message:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>Employees are required to set up an Out of Office email autoresponder that includes the following information:</li>
//             <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//               <li>Dates of absence (start and end)</li>
//               <li>Reason for absence (if comfortable sharing)</li>
//               <li>Alternate contact person/coverage for the duration of absence</li>
//               <li>A note that the employee will respond to emails upon return</li>
//             </ul>
//           </ul>

//           <p><strong>4. Duration of Absence:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees should specify the duration of their absence clearly. For longer absences (more than [X days]), employees are encouraged to discuss their workload and responsibilities with their supervisor beforehand.
//             </li>
//           </ul>

//           <p><strong>5. Emergency Contacts:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               If urgent matters arise during the employee's absence, the autoresponder should provide an alternative contact person who can assist in their absence.
//             </li>
//           </ul>

//           <p><strong>6. Return Notification:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Employees should notify their supervisor and team upon their return to the office. This ensures that everyone is aware of their availability and can resume regular communications.
//             </li>
//           </ul>

//           <p style={{ margin: "15px 0 5px 0" }}><strong>7. Documentation:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6", marginTop: "0" }}>
//             <li>
//               For planned absences (e.g., vacations, medical leaves), employees may be required to submit formal documentation (e.g. medical certificates) as per the company’s leave policy.
//             </li>
//           </ul>
//         </section>


//         <section className="policy-team-limits" style={{ marginTop: '0px' }}>
//           <strong>8. Team-Specific Absence Limits:</strong>
//           <p>The following guidelines specify the maximum number of employees allowed to be Out of Office (OOP) per team at the same time:</p>
//           <div style={{ background: 'rgba(255,255,255,0.05)', padding: '15px', borderRadius: '8px', marginTop: '10px' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
//               <thead>
//                 <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.2)', textAlign: 'left' }}>
//                   <th style={{ padding: '8px' }}>Team Name</th>
//                   <th style={{ padding: '8px' }}>Max. allowed employees on OOP</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {[
//                   ["FSP LO / FI IE", "02"],
//                   ["DDI", "01"], ["DMS", "01"], ["IQ Program", "01"],
//                   ["FI MeGA", "02"], ["FI Elec", "01"], ["FI Structural/PC", "01"],
//                   ["LTO", "01"]
//                 ].map(([team, limit], idx) => (
//                   <tr key={idx} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
//                     <td style={{ padding: '8px' }}>{team}</td>
//                     <td style={{ padding: '8px', fontWeight: 'bold', color: '#00bcd4' }}>{limit}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </section>

//         <section>
//           <p><strong>9. Responsibilities:</strong></p>

//           <p><strong>Employee:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>It is the employee's responsibility to ensure that all necessary notifications are made and that their workload is managed appropriately prior to their absence.</li>
//             <li>If OOP is not approved in the system, it is the employee’s responsibility to get it approved by reaching out to their respective managers.</li>
//             <li>Based on a first-come, first-served basis, approvals will be processed in the order requests are received.</li>
//             <li>Once your OOP is approved in the GTELinq system, ensure that you are putting your OOP in customers’ Outlook and Teams portal.</li>
//           </ul>

//           <p><strong>Supervisor/Manager:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>Supervisors are responsible for ensuring that team members understand and adhere to this policy.</li>
//             <li>They should assist in reallocating tasks if necessary to ensure continuity during absences.</li>
//           </ul>
//         </section>

//         <section>
//           <p><strong>10. Coverage:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>The project on which an individual employee is working should always have coverage, and it is the employee’s responsibility to make proper arrangements.</li>
//             <li>Future project/task that is assigned to you and has not started yet should also have coverage member listed regardless of its start date being after your return.</li>
//             <li>This is because projects/tasks may get pulled in while you are on leave so we want to ensure all projects are properly resourced.</li>
//             <li>For projects that have already been completed, there should be general coverage.</li>
//           </ul>
//         </section>
//         <section >
//           <p><strong>11. Noncompliance:</strong></p>
//           <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
//             <li>
//               Failure to adhere to the Out of Office policy may result in disciplinary actions such as unpaid leaves with deduction of an equal number of leaves from the earned leaves, as it can disrupt workflow and affect team productivity.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>12. Major medical emergencies</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>A major medical emergency is scenario which restricts you from coming to work and performing your job duties either from office or work.</li>
//             <li>This involves case when you are hospitalized.</li>
//             <li>Genesis Tech supports all their employees in times of such emergencies, and we want to make sure employees get every possible support from the team and their manager.</li>
//             <li>As you will be away from office for longer than usual duration following scenarios may apply to you on a case-by-case basis.</li>
//             <li>The number of days you are OOP will be evaluated against your pending SL and EL and will be adjusted against the pending leaves you have.</li>
//             <li>In case you do not have any leaves in the current financial year, it will result in a pay cut.</li>
//             <li>Pay deduction may happen for the number of days you were OOP without impacting your leave counts.</li>
//             <li>Your manager will discuss this with you once you are back in the office and one appropriate option from above will be applied.</li>
//           </ul>
//         </section>
//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           OUT OF OFFICE (OOO) POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },

//   {
//     id: 5,
//     title: "Public Holidays for 2026",
//     icon: "🎉",
//     content: (
//       <div className="policy-details-text">



//         <div className="okr-table-wrapper">

//           <div style={{ marginBottom: '15px', fontSize: '16px', lineHeight: '1.5' }}>
//             <p><strong>Note:</strong></p>
//             <ul style={{ paddingLeft: '20px', lineHeight: '1.5', marginTop: '5px' }}>
//               <li>Total allowable national holidays in a year are 10.</li>
//               <li>Not all festivals get their spot on the holiday calendar every year, as the number of festivals we celebrate across India is more than 10.</li>
//               <li>Overall holidays are adjusted to limit to 10, and you may see some holidays which were given in last year may not be in the list to limit the total count of national holidays to 10.</li>
//             </ul>
//           </div>

//           <table className="okr-modern-table" style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '30px' }}>
//             <thead>
//               <tr style={{ backgroundColor: '#f8f9fa' }}>
//                 <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Sr.No</th>
//                 <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Festival</th>
//                 <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Date</th>
//                 <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Day</th>
//               </tr>
//             </thead>
//             <tbody>
//               {[
//                 ["1", "New Year", "1-Jan-2026", "Thursday"],
//                 ["2", "Republic Day", "26-Jan-2026", "Monday"],
//                 ["3", "Gudi Padwa", "19-Mar-2026", "Thursday"],
//                 ["4", "Maharashtra Day", "1-May-2026", "Friday"],
//                 ["5", "Bakrid", "27-May-2026", "Wednesday"],
//                 ["6", "Ganesh Chaturthi", "14-Sep-2026", "Monday"],
//                 ["7", "Gandhi Jayanti", "2-Oct-2026", "Friday"],
//                 ["8", "Dussehra", "20-Oct-2026", "Tuesday"],
//                 ["9", "Diwali", "9-Nov-2026", "Monday"],
//                 ["10", "Christmas", "25-Dec-2026", "Friday"]
//               ].map(([sr, fest, date, day], idx) => (
//                 <tr key={idx}>
//                   <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{sr}</td>
//                   <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{fest}</td>
//                   <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{date}</td>
//                   <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{day}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           PUBLIC HOLIDAY POLICY-R00-01/MAR/2026
//         </div>

//       </div>
//     )
//   },
//   {
//     id: 6,
//     title: "Performance Of Duties",
//     icon: "⚖️",
//     content: (
//       <div className="policy-details-text">
//         <section>
//           <strong>1. Performance Of Duties</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
//             <li>The Employee agrees that during the Employment Period, he/she shall devote his/her full business time to the business affairs of the Company and shall perform the duties assigned to him/her faithfully and efficiently, and shall endeavor, to the best of his/her abilities to achieve the goals and adhere to the parameters set by the Company.</li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Responsibilities</strong>
//           <p>The Employee shall be responsible for:</p>
//           <p style={{ paddingLeft: '20px' }}>• Devoting the whole time, attention and abilities to the business of Genesis Tech Engineers unless prevented by illness.</p>
//           <p style={{ paddingLeft: '20px' }}>• Diligently perform such duties as may from time to time be assigned to you.</p>
//           <p style={{ paddingLeft: '20px' }}>• Comply with all reasonable and lawful directions given to you by Genesis Tech Engineers and your managers.</p>
//           <p style={{ paddingLeft: '20px' }}>• Act in good faith and in the best interest of Genesis Tech Engineers and its customers and staff always, including reporting your own wrongdoing and any wrongdoing of any  other employee immediately on becoming aware of it.</p>
//           <p style={{ paddingLeft: '20px' }}>• Promote, Protect, Develop, and extend the business of Genesis Tech Engineers.</p>
//           <p style={{ paddingLeft: '20px' }}>• Take all reasonable steps in respect of the help and safety of yourself, colleagues, and third parties.</p>
//         </section>

//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           PERFORMANCE OF DUTIES POLICY-R00-01/MAR/2026
//         </div>

//       </div>
//     )
//   },

//   {
//     id: 7,
//     title: "Fair Compensation",
//     icon: "💰",
//     content: (

//       <div className="policy-details-text">
//         <header className="policy-header-container">

//         </header>
//         <section>
//           <p>Subject to the following provisions of this Agreement, during the Employment Period, the Employee shall be compensated for his services as follows. All compensation related activities are based on Financial Year (i.e. Apr -Mar) and not regular calendar year (Jan-Dec). </p>
//         </section>

//         <section>
//           <strong>1. Annual Salary</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
//             <li>The Employee shall receive an annual salary, payable monthly by the Employer. Subject to such increases from time to time, as determined by the Employer. Such payments shall be subject to such normal statutory deductions by the Employer.</li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Payment Method</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
//             <li>During the term of this Agreement, the Employee's salary shall be paid by means of bank transfer, cheque, or any other method convenient to the Employer, and consented to by the Employee.</li>
//           </ul>
//         </section>

//         <div>
//           <strong>3. Term insurance Policy</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
//             <li>As a part of your overall CTC package Genesis Tech will work on issuing Term insurance policy for every employee.</li>
//             <li>The term insurance policy will be issued anytime between joining to 7month service at Genesis.</li>

//             <li>
//               <strong>Policy Payments:</strong>
//               <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
//                 <li>The annual installment amount depends on multiple factors and can vary for employee to employee.</li>
//                 <li>Age, physical condition, medical test reports will define your policy premium value.</li>
//               </ul>
//             </li>

//             <li>As a part of CTC Genesis will bear certain majority portion of your policy (varies for all employees) to match your CTC and employees will be responsible to pay the excess amount.</li>
//             <li>The policy duration is 10 years.</li>
//             <li>Genesis Tech will keep on paying the annual premium amount util you are employed with Genesis Tech.</li>
//             <li>As this is administrative item, for any further questions regarding your insurance policy direct all your questions to HR. Your manager will not have details to your specific policy that applies to you.</li>
//           </ul>
//         </div>
//         <div style={{ marginTop: "25px" }}>
//           <strong>4. Annual Bonus:</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
//             <li>Annual bonus is awarded in Diwali every year.</li>
//             <li>Annual bonus are prorated based on your joining date in a financial year.</li>
//             <li>The annual bonus is awarded based on the last financial year service you performed.</li>

//             <li>
//               Examples below:
//               <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
//                 <li>If an employee joined on 1st June2025, the financial year will end on 31st March 2026 and the employee will get the annual bonus for duration of 1st June 2025 to 31st March 2026 during Diwali of 2026.</li>
//                 <li>For employees who were employed for full financial year they will get their 1st April 2025 to 31st March 2026 bonus pay in Diwali of 2026.</li>
//               </ul>
//             </li>

//           </ul>
//         </div>
//         <div style={{ marginTop: "25px" }}>
//           <strong>5. Provident Fund:</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
//             <li>Provident Fund (PF) has 2 portions employees part and employers part.</li>
//             <li>The employees part is deducted from their monthly pay and the deduction is mentioned on your pay slip.</li>
//             <li>The employer part is directly deposited into your PF account.</li>
//             <li>All employees are encouraged to have UMANG app to check your PF balance and confirm any details you might want to view regarding your PF.</li>
//           </ul>
//         </div>

//         <div style={{ marginTop: "25px" }}>
//           <strong>6. Professional Tax:</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
//             <li>Professional Tax (PT) of Rs.200/- per month is deducted from your salary.</li>
//             <li>This deduction is also listed on your payslip.</li>
//           </ul>
//         </div>


//         <section style={{ marginTop: '10px' }}>
//           <strong>7. Reimbursement Guidlines</strong>
//           <p><strong>Definition:</strong> Reimbursement is when you make an expense pre-approved by your manager on behalf of company for official purposes.</p>
//           <p>• Employees must log in to the GTELinq portal and submit the reimbursement form.</p>
//           <p>• You are required to upload all receipts for your requests.</p>
//           <p>• The receipt must be readable.</p>
//           <p>• The receipt should be in company name.</p>
//           <p>• Where GST billing can be done you should proceed with getting a GST bill.</p>
//           <p>• When asking for GST bill you must tell the seller/supplier to enter company’s full name and GST number to be included on the bill/receipt. Details are as follows:</p>
//           <div style={{ paddingLeft: '20px', margin: '10px 0' }}>
//             <strong>Name:</strong> GENESIS TECH ENGINEERS PVTD LTD.<br />
//             <strong>GST NO.:</strong> 27AAKCG7985R1ZB
//           </div>
//           <p>• The bill must be submitted in the same month within 2 days of making the transaction.</p>
//           <p>• The reimbursement will be routed to your manager for approval.</p>
//           <p>• Once manager approves the money will be deposited in the current month pay cycle.</p>
//           <p>• If the pay cycle is within 7 days of submitting the bill the payment will be released in the following pay cycle.</p>
//         </section>
//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           FAIR COMPENSATION POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },
//   {
//     id: 8,
//     title: "Obligations of the Employee",
//     icon: "📝",
//     content: (


//       <div className="policy-details-text">
//         <header className="policy-header-container">

//         </header>


//         <section>
//           <strong>1. Legal Conduct</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               Upon execution of the employment agreement, the Employee shall not engage in any sort of theft, fraud, misrepresentation, or any other illegal act neither in the employment space nor outside the premise of employment. If he/she does so, the Company shall not be liable for such acts done at his/her own risk.
//             </li>
//             <li>
//               The Employee further promises to never engage in any theft of the Employer’s property or attempt to defraud the Employer in any manner.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Compliance with Rules</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations, and policies of the Company as notified from time to time.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>3. Exclusive Service</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee shall not take up part-time or full-time employment or consultation with any other party or be involved in any other business during the term of his/her employment with the Company.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>4. Return of Property</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               On termination, the Employee shall immediately return to the Employer all documents, books, materials, records, correspondence, papers and information (on whatever media and wherever located) relating to the Employer’s business or affairs, or relating to the Employer’s business contacts, any keys, credit cards, access cards, and any other property of the Employer, which is in the Employee’s possession or under the Employee’s control.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>5. Specific Policies</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations, and policies of the Company as notified from time to time, including but not limited to the Leave Policy and Sexual Harassment Policy.
//             </li>
//             <li>
//               The Employer prohibits the Employee from engaging in any form of sexual harassment and the Employee promises to refrain from any form of sexual harassment during employment in and around the premises of employment. If the Employee violates this term in the agreement, he/she shall be fully responsible for his/her actions, and the Employer shall not be held responsible for any illegal acts committed at the discretion of the Employee.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>6. Dress Code</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>Monday of every week is formal wear day.</li>
//             <li>Other days in the week are casual wears suitable for the office environment.</li>
//           </ul>
//         </section>

//         <section>
//           <strong>7. Use of common areas in building premises and offices:</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>Common building spaces must be used hygienically.</li>
//             <li>Everyone using the space must ensure they are not causing spills and keep the place clean.</li>
//           </ul>
//         </section>

//         <section>
//           <strong>8. ID Cards:</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>ID cards are compulsory in the office. You must wear them at all times while on the building campus.</li>
//           </ul>
//         </section>
//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           OBLIGATION OF THE EMPLOYEE POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },
//   {
//     id: 9,
//     title: "Assignments",
//     icon: "📋",
//     content: (
//       <div className="policy-details-text">
//         <header className="policy-header-container">
//           {/* <h2 className="policy-main-title">Assignment</h2> */}
//         </header>

//         <section>
//           <strong>1. Works Made for Hire</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee acknowledges that any work including, without limitation, inventions, designs, ideas, concepts, drawings, working notes, artistic works that the Employee may individually or jointly conceive or develop during the term of Employment are “works made for hire.”
//             </li>
//             <li>
//               To the fullest extent permitted by law, the Employee shall assign, and does hereby assign, to the Employer all of the Employee's right, title, and interest in and to all Intellectual Property improved, developed, discovered, or written in such works.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Documentation and Vesting</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee shall, upon request of the Employer, execute, acknowledge, deliver, and file any and all documents necessary or useful to vest in the Employer all of the Employee's right, title, and interest in and to all such matters.
//             </li>
//           </ul>
//         </section>
//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           ASSIGNMENTS POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },
//   {
//     id: 10,
//     title: "Confidentiality",
//     icon: "🔒",
//     content: (
//       <div className="policy-details-text">
//         <header className="policy-header-container"></header>

//         <section>
//           <strong>1. Access to Information</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee acknowledges that, while performing and fulfilling his/her duties hereunder, he/she may have access to and be entrusted with confidential information concerning the present and contemplated financial status and activities of the Employer.
//             </li>
//             <li>
//               The disclosure of any of this confidential information to competitors of the Employer would be highly detrimental to the interests of the Employer.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Proprietary Rights</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee further acknowledges and agrees that the right to maintain the confidentiality of trade secrets, source code, website information, business plans, client information, or other confidential or proprietary information constitutes a proprietary right.
//             </li>
//             <li>
//               The Employer is entitled to protect this proprietary right.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>3. Non-Disclosure Covenant</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employee covenants and agrees that he/she will not, under any circumstance during the continuance of this agreement, disclose any such confidential information to any person, firm, or corporation.
//             </li>
//             <li>
//               The Employee shall not use the confidential information except as required in the normal course of engagement.
//             </li>
//             <li>
//               Even after termination of employment, the Employee shall not disclose or make use of the confidential information, nor cause it to be disclosed in any manner.
//             </li>
//           </ul>
//         </section>

//         <section>
//           <strong>4. Intellectual Property Ownership</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               The Employer owns any intellectual property created by the Employee during employment, or in relation to a certain field, and has all necessary rights to retain it.
//             </li>
//             <li>
//               After termination of employment, the Employee shall not claim any rights on the intellectual property created.
//             </li>
//             <li>
//               Any source code, software, or other intellectual property developed, including website design or functionality created by the Employee during employment under this Agreement, shall belong to the Employer.
//             </li>
//           </ul>
//         </section>

//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           CONFIDENTIALITY POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   },



//   {
//     id: 11,
//     title: "Employee Termination",
//     icon: "🚫",
//     content: (
//       <div className="policy-details-text">
//         <header className="policy-header-container"></header>

//         <section>
//           <strong>1. Employer Termination</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>The Employer may terminate your employment without any notice.</li>
//           </ul>
//         </section>

//         <section>
//           <strong>2. Employee Resignation</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>The Employee may terminate his/her employment by providing the Employer with at least 2-month(s) advance notice of his/her intention to resign.</li>
//           </ul>
//         </section>


//         <section>
//           <strong>3. Notice Period</strong>
//           <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//             <li>
//               For employees wishing to terminate their employment with Genesis Tech will be considered to opt for one of the two options listed below:
//               <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//                 <li>Immediate termination (0 Day notice period served)</li>
//                 <li>Full notice period served (60 Day notice period served)</li>
//               </ul>
//               Based on option that employee chooses the following process will be applicable to complete employees exit procedures.
//             </li>
//           </ul>
//         </section>


//         <section>
//           <strong>4. Exit Procedure Policy</strong>
//           <div style={{ marginTop: '20px' }}>
//             <strong>Case 1:</strong>

//             <p style={{ marginTop: '10px' }}>
//               A clean exit procedure at GTE is meeting the following 2 criteria listed-
//             </p>

//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>Service Agreement Duration: 2 years</li>
//               <li>Notice period: 2 months post completion of service agreement.</li>
//             </ul>

//             <p style={{ marginTop: '10px' }}>
//               If the above criteria is met, the process will occur in following sequence-
//             </p>

//             <p style={{ marginTop: '15px' }}><strong>Documentation</strong></p>
//             <p style={{ marginTop: '5px' }}>
//               GTE will provide you with following documentation as a part of exit procedures-
//             </p>
//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>Relieving Letter</li>
//               <li>Experience Letter</li>
//               <li>Payslip of last month of service at GTE</li>
//               <li>Handover of any original documents submitted</li>
//               <li>Signing of form stating receipt of original documents (A copy will be provided to employee)</li>
//             </ul>

//             <p style={{ marginTop: '15px' }}><strong>Finances</strong></p>
//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>Pay for last month of employment at GTE.</li>
//               <li>Payment of earned leaves accumulated while being at GTE.</li>
//             </ul>

//             <p style={{ marginTop: '15px' }}>
//               The documentation and financial settlement will take place within 2 business days.
//             </p>
//           </div>

//           <section>
//             <strong>Notice Period Violation:</strong>
//             <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//               <li>
//                 In the event where notice period could not be served by the employee, they must discuss with their manager a plan of exiting immediately by paying 2 months of your pay for notice period duration. Once the payment is made you will be entitled to receive the following documents:
//                 <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
//                   <li>Relieving Letter</li>
//                   <li>Experience Letter</li>
//                   <li>Return of original documents submitted at the time of joining</li>
//                   <li>Pay and Payslip of your last month of service at GTE</li>
//                 </ul>
//               </li>


//             </ul>
//           </section>

//           <div style={{ marginTop: '20px' }}>
//             <strong>Case 2:</strong>

//             <p style={{ marginTop: '10px' }}>Any duration which is less than 2 years of service agreement.</p>

//             <p style={{ marginTop: '10px' }}>
//               In event when you choose to leave prior to end of your service agreement duration, you are required to complete the 2 months’ notice period as a mandatory requirement.
//             </p>

//             <p style={{ marginTop: '10px' }}>The process will occur in following sequence-</p>

//             <p style={{ marginTop: '15px' }}><strong>Finances</strong></p>
//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>GTE will recover the cost for time invested in training.</li>
//               <li>This is 6 months of your pay (your probation duration).</li>
//               <li>GTE will send pending dues notice for the same.</li>
//             </ul>

//             <p style={{ marginTop: '15px' }}>Until the above criteria is satisfied all the items below will be withheld.</p>
//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>Pay for last month of employment.</li>
//               <li>Payment of earned leaves accumulated.</li>
//             </ul>

//             <p style={{ marginTop: '15px' }}>
//               The above payments will be used against your financial dues and the financial dues notice will include all the respective details.
//             </p>

//             <p style={{ marginTop: '15px' }}><strong>Documentation on hold</strong></p>
//             <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
//               <li>Relieving Letter</li>
//               <li>Experience Letter</li>
//               <li>Return of original documents submitted at the time of joining.</li>
//               <li>Payslip of last month of service at GTE</li>
//             </ul>


//             <section>
//               <strong>Notice Period Violation:</strong>
//               <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>

//                 <li>
//                   You are liable to follow the requirements mentioned under the section “Case 2” along with additional payment of 2 months of notice period to be considered for a complete exit procedure.
//                 </li>
//                 <li>GTE will not allow you to serve partial duration of notice period.</li>
//               </ul>
//             </section>
//           </div>

//           <div style={{ marginTop: '15px', paddingTop: '15px' }}>
//             <p><strong>5. In the event where any of the above conditions are not met the employee is not entitled to receive:</strong></p>
//             <ul style={{ paddingLeft: '20px' }}>
//               <li>Relieving Letter.</li>
//               <li>Experience Letter.</li>
//               <li>Return of original documents submitted at the time of joining.</li>
//               <li>Pay and Payslip of your last month of service at GTE.</li>
//             </ul>
//           </div>

//           <div style={{ marginTop: '15px' }}>
//             <p><strong>6. Employee Responsibility:</strong></p>
//             <ul style={{ paddingLeft: '20px' }}>
//               <li>Schedule a 1:1 with your manager and discuss your departure plan.</li>
//               <li>Send official email of resignation to hr@genesistech.co.in with your manager copied on the email.</li>
//               <li>Make sure all office belongings are returned back to your manager. This includes your laptop, charger, headset, notebooks, notes in any form etc.</li>
//             </ul>
//           </div>

//           <div style={{ marginTop: '15px' }}>
//             <p><strong>7. Manager’s responsibilities:</strong></p>
//             <ul style={{ paddingLeft: '20px' }}>
//               <li>Ensure all the above things are met in order for successful completion of employee relieving process.</li>
//             </ul>
//           </div>
//         </section>



//         <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
//           EMPLOYEE TERMINATION POLICY-R00-01/MAR/2026
//         </div>
//       </div>
//     )
//   }


// ];

// const CompanyPolicy = ({ userData }) => {
//   const [companyLogo, setCompanyLogo] = useState("");
//   const [selectedPolicy, setSelectedPolicy] = useState(null);
//   const [logs, setLogs] = useState({});
//   const [loading, setLoading] = useState(false);

//   const empBadgeId = userData?.EmpId || userData?.employeeId;
//   const fullName = `${userData?.FirstName || ''} ${userData?.LastName || ''}`.trim();
//   const API_URL = "/gt-api/acknowledgepolicy.php";

//   useEffect(() => {
//     const fetchMyLogs = async () => {
//       if (!empBadgeId) return;

//       try {
//         const response = await fetch(`${API_URL}?empId=${empBadgeId}`);
//         const result = await response.json();

//         const logsArray = result.logs || [];

//         const signedMap = logsArray.reduce((acc, curr) => {
//           if (curr.policy_title) {
//             acc[curr.policy_title] = true;
//           }
//           return acc;
//         }, {});

//         setLogs(signedMap);

//       } catch (e) {
//         console.error("Failed to load policy signatures:", e);
//       }
//     };

//     fetchMyLogs();
//   }, [empBadgeId]);

//   const handleReadStatus = async (policyTitle) => {
//     if (!empBadgeId) {
//       alert("User Session Missing: EmpId not found. Please log out and back in.");
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await fetch(API_URL, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           empId: empBadgeId,
//           fullName: fullName,
//           policyTitle: policyTitle
//         }),
//       });
//       const result = await response.json();
//       if (result.status === "success") {
//         setLogs(prev => ({ ...prev, [policyTitle]: true }));
//       } else {
//         alert("Server Error: " + (result.message || "Could not save."));
//       }
//     } catch (error) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const isRead = (title) => logs[title] || false;

//   const [companyPolicies, setCompanyPolicies] = useState([]);
//   const isGenesis =
//     userData?.EmailId?.toLowerCase().includes("genesistech.co.in") ||
//     userData?.EmailId?.toLowerCase().includes("gtecorpgroup.com") ||
//     userData?.EmailId?.toLowerCase().includes("gtcorpgroup.com");
//   useEffect(() => {
//     if (isGenesis) return;

//     fetch(
//       "/gt-api/get_policies.php",
//       {
//         credentials: "include"
//       }
//     )
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) {
//           setCompanyPolicies(data.policies || []);
//         }
//       });
//   }, [isGenesis]);

//   useEffect(() => {
//     const email = userData?.EmailId || "";
//     const domain = email.split("@")[1]?.toLowerCase();
//     if (!domain) return;

//     fetch(
//       "/gt-api/get_company_logo.php",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({ domain })
//       }
//     )
//       .then(res => res.json())
//       .then(data => {
//         if (data.success && data.company_logo) {
//           setCompanyLogo(
//             `/gt-api/${data.company_logo}`
//           );
//         }
//       })
//       .catch(console.error);
//   }, [userData]);

//   const policies = isGenesis
//     ? GENESIS_POLICIES
//     : companyPolicies;

//   return (
//     <div className="policy-wrapper">

//       {/* ================= DESKTOP VIEW ================= */}
//       <div className="desktop-policy-layout">

//         {/* Sidebar */}
//         <div className="policy-sidebar-nav glass">
//           <div className="sidebar-header"></div>

//           <div className="policy-menu">
//             {policies.map((p) => (
//               <div
//                 key={p.id}
//                 className={`policy-item ${selectedPolicy?.id === p.id ? "active" : ""
//                   }`}
//                 onClick={() => setSelectedPolicy(p)}
//               >
//                 <div className="active-indicator"></div>

//                 <span className="p-icon">
//                   {isGenesis ? p.icon : p.policy_icon}
//                 </span>

//                 <span className="p-text">
//                   {isGenesis ? p.title : p.policy_title}
//                 </span>

//                 {isRead(
//                   isGenesis ? p.title : p.policy_title
//                 ) && <span className="p-status-check">✅</span>}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Viewer */}
//         <div className="policy-viewer glass">
//           {selectedPolicy ? (
//             <div className="viewer-content animate-fade">

//               <div className="viewer-header">
//                 <div className="header-info">
//                   <h1>
//                     {isGenesis
//                       ? selectedPolicy.title
//                       : selectedPolicy.policy_title}
//                   </h1>
//                 </div>
//               </div>

//               <div className="cyber-divider"></div>

//               <div className="document-body">
//                 <section className="doc-section">

//                   {isGenesis ? (
//                     selectedPolicy.content
//                   ) : (
//                     <div
//                       style={{ lineHeight: "1.9" }}
//                       dangerouslySetInnerHTML={{
//                         __html: selectedPolicy.policy_content
//                           .split("\n")
//                           .map((line) => {
//                             const trimmed = line.trim();

//                             if (!trimmed) return "<br>";

//                             if (/^\d+\./.test(trimmed)) {
//                               return `<br><strong>${trimmed}</strong><br>`;
//                             }

//                             return `• ${trimmed}<br>`;
//                           })
//                           .join("")
//                       }}
//                     />
//                   )}

//                 </section>

//                 <div
//                   className="acknowledgement-section"
//                   style={{
//                     marginTop: "40px",
//                     padding: "20px",
//                     backgroundColor: "rgba(255,255,255,0.05)",
//                     borderRadius: "8px",
//                     textAlign: "center"
//                   }}
//                 >
//                   <button
//                     className={`read-button ${isRead(
//                       isGenesis
//                         ? selectedPolicy.title
//                         : selectedPolicy.policy_title
//                     )
//                       ? "disabled"
//                       : ""
//                       }`}
//                     onClick={() =>
//                       handleReadStatus(
//                         isGenesis
//                           ? selectedPolicy.title
//                           : selectedPolicy.policy_title
//                       )
//                     }
//                     disabled={isRead(
//                       isGenesis
//                         ? selectedPolicy.title
//                         : selectedPolicy.policy_title
//                     )}
//                   >
//                     {isRead(
//                       isGenesis
//                         ? selectedPolicy.title
//                         : selectedPolicy.policy_title
//                     )
//                       ? "✓ Policy Acknowledged"
//                       : "Read and Understood"}
//                   </button>
//                 </div>
//               </div>

//               <div className="policy-footer">
//                 {/* <p>© Genesis Tech Engineers Pvt. Ltd.</p> */}
//               </div>

//             </div>
//           ) : (
//             <div className="empty-policy-wrapper">
//               <div className="empty-policy-state">
//                 <img
//                   src={companyLogo || logoWhite}
//                   alt="Company Logo"
//                   style={{
//                     width: "350px",
//                     height: "auto",
//                     marginBottom: "80px"
//                   }}
//                 />

//                 <p className="empty-policy-text">
//                   PICK A POLICY FROM THE SIDEBAR TO READ IT.
//                 </p>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ================= MOBILE VIEW ================= */}

//       {!selectedPolicy ? (
//         <div className="mobile-policy-list">

//           {policies.map((p) => (
//             <div
//               key={p.id}
//               className="mobile-policy-card"
//               onClick={() => setSelectedPolicy(p)}
//             >
//               <div className="mobile-policy-header">

//                 <span className="mobile-policy-icon">
//                   {isGenesis ? p.icon : p.policy_icon}
//                 </span>

//                 <span className="mobile-policy-title">
//                   {isGenesis ? p.title : p.policy_title}
//                 </span>

//               </div>

//               {isRead(
//                 isGenesis ? p.title : p.policy_title
//               ) && (
//                   <div className="mobile-policy-status">
//                     ✅ Acknowledged
//                   </div>
//                 )}
//             </div>
//           ))}

//         </div>
//       ) : (
//         <div className="mobile-policy-viewer">

//           <button
//             className="mobile-policy-back-btn"
//             onClick={() => setSelectedPolicy(null)}
//           >
//             ← BACK TO POLICIES
//           </button>

//           <h2 className="mobile-policy-heading">
//             {isGenesis
//               ? selectedPolicy.title
//               : selectedPolicy.policy_title}
//           </h2>

//           <div className="mobile-policy-content">

//             {isGenesis ? (
//               selectedPolicy.content
//             ) : (
//               <div
//                 style={{ lineHeight: "1.9" }}
//                 dangerouslySetInnerHTML={{
//                   __html: selectedPolicy.policy_content
//                     .split("\n")
//                     .map((line) => {
//                       const trimmed = line.trim();

//                       if (!trimmed) return "<br>";

//                       if (/^\d+\./.test(trimmed)) {
//                         return `<br><strong>${trimmed}</strong><br>`;
//                       }

//                       return `• ${trimmed}<br>`;
//                     })
//                     .join("")
//                 }}
//               />
//             )}

//           </div>

//           <div className="acknowledgement-section mobile-ack">

//             <button
//               className={`read-button ${isRead(
//                 isGenesis
//                   ? selectedPolicy.title
//                   : selectedPolicy.policy_title
//               )
//                 ? "disabled"
//                 : ""
//                 }`}
//               onClick={() =>
//                 handleReadStatus(
//                   isGenesis
//                     ? selectedPolicy.title
//                     : selectedPolicy.policy_title
//                 )
//               }
//               disabled={isRead(
//                 isGenesis
//                   ? selectedPolicy.title
//                   : selectedPolicy.policy_title
//               )}
//             >
//               {isRead(
//                 isGenesis
//                   ? selectedPolicy.title
//                   : selectedPolicy.policy_title
//               )
//                 ? "✓ Policy Acknowledged"
//                 : "Read and Understood"}
//             </button>

//           </div>

//         </div>
//       )}

//     </div>
//   );
// };

// export default CompanyPolicy;

































import React, { useState, useEffect } from 'react';
import '../styles/CompanyPolicy.css';
import logoWhite from '../assets/logowhite.png';

export const GENESIS_POLICIES = [
  {
    id: 1,
    title: "Probation Policy",
    icon: "⏳",
    content: (

      <div className="policy-details-text">
        <header className="policy-header-container">

        </header>
        <section>
          <p><strong>1. Purpose & Scope</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              The purpose of this policy is to define the terms and conditions applicable during the six-month probationary period for new employees at Genesis Tech Engineers Pvt. Ltd. This period is intended to evaluate the employee’s performance, compatibility with company culture, and overall suitability for the role. This policy applies to all newly hired employees who are undergoing their initial six-month probationary period at Genesis Tech Engineers Pvt. Ltd.
            </li>
          </ul>
        </section>

        <section>
          <p><strong>2. Duration and Assessment</strong></p>
          <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
            <li>All new employees must undergo a probationary period lasting six (6) months from their official start date. The probationary period is designed to assess the employee’s performance and fit within the company.</li>

            <li>Your manager at the end of your 6 month probation period may decide to extend your probation period for 3 additional months. This is so that your manager still believes in your abilities and that your performance will meet the requirements of clearing the probation period.</li>

            <li>There is only one time extension to probation duration.</li>

            <li>Manager will submit a performance review at the end of your probation period to HR.</li>
          </ul>
        </section>

        <section>
          <p><strong>3. Leave Entitlements & Penalties</strong></p>
          <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
            <li>During the probationary period, employees are not entitled to any leaves. Only emergency case leaves will be approved and will be counted towards the earned leave.</li>

            <li>If leaves are taken the penalty will be +1 or +2 additional leaves deducted from your earned leave based on scenarios mentioned below.</li>

            <li>If employee takes below or up to 2 days leave during probation, then +1 rule will apply i.e. 1 additional earned leave will deducted.</li>

            <li>If an employee takes leave for more than 2 days during probation then +2 rule will apply i.e additional 2 days of earned leave will be deducted from the overall leaves they applied.</li>
          </ul>
        </section>
        <section>
          <p><strong>4. Performance Review & Confirmation</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Performance evaluations will be conducted periodically throughout the probationary period to assess the employee’s performance, adherence to company policies, and overall suitability for the position. A formal review will occur at the end of the probationary period to determine whether the employee will be confirmed as a permanent staff member.
            </li>
          </ul>
        </section>

        <section className="policy-note-red">
          <p><strong>5. Termination</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Employment may be terminated at any time during the probationary period, with or without notice, if the employee’s performance or conduct does not meet the standards set by Genesis Tech Engineers Pvt. Ltd. The standard notice period, as outlined in the employment contract, will apply unless otherwise specified.
            </li>
          </ul>
        </section>
        <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
          PROBATION POLICY-R00-01/MAR/2026
        </div>
      </div>
    )
  },
  {
    id: 2,
    title: "WFH Policy",
    icon: "🏠",
    content: (
      <div className="policy-details-text">
        <section style={{ marginBottom: '20px' }}>
          <p><strong>1. Purpose:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              The Work from Home (WFH) option is provided as an additional benefit to support employees in extreme case of emergency, a personal obligation that may prevent office attendance. This allows employees to work from a location other than the office on a limited basis, as long as they can effectively fulfill their responsibilities without disrupting daily operations or team productivity. At Genesis Tech we do not entertain any WFH request unless the reason is compelling. The reason should be fully disclosed and explained to manager in order for the request to be considered with an awareness of high chances of the request getting denied.
            </li>
          </ul>
        </section>
        <section style={{ marginBottom: "15px" }}>
          <p><strong>Annual WFH Allocation:</strong></p>

          <ul
            style={{
              paddingLeft: "20px",
              marginTop: "0px",
              lineHeight: "1.6",
            }}
          >
            <li>WFH is not allowed during probation phase of your employment.</li>

            <li>
              The allowance is <span className="wfh-span-bold">12 WFH days per calendar year.</span>
            </li>

            <li>
              Unused WFH days <span className="wfh-span-bold">will not carry forward</span> to the following
              calendar year.
            </li>

            <li>
              Employees are responsible for keeping track of their remaining WFH quota.
            </li>

            <li>
              WFH requests should be submitted in advance through the normal
              leave/WFH application process in GTELinq.
            </li>

            <li>
              Once an employee has used all 12 WFH days,{" "}
              <span className="wfh-span-bold">
                no additional WFH days will be granted during that calendar year.
              </span>
            </li>

            <li>
              WFH is a flexibility provided by the Company and should not impact
              productivity, deliverables, availability, communication or customer
              commitments.
            </li>

            <li>
              Employees are expected to maintain the same level of professionalism,
              responsiveness, working hours, and performance while working remotely as
              they would from the office.
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '15px' }}>
          <strong>2. Request Process:</strong>
          <ul style={{ paddingLeft: '20px', marginTop: '8px', lineHeight: '1.6' }}>
            <li>
              WFH requests should be submitted to the manager by writing an email at least 2 days in advance describing the detailed reason for request.
            </li>
            <li>
              If the manager does not respond to your email by the date of when you want to start your WFH you must consider that the request is rejected.
            </li>
            <li>
              Requesting WFH that does not fit the 2 day request window will be denied regardless of the reason.
            </li>
            <li>
              Failure to apply for WFH within 24hrs in events of emergency or any other scenario will result in the equal number plus 1 day of penalty earned leave deducted from your leave quota.
              <ul style={{ paddingLeft: '25px', marginTop: '8px' }}>
                <li>
                  E.g. If you took 2 days WFH and could not apply it in system due to an emergency system within 24hrs of your return to office, 3WFH days and 3 Earned Leaves will be deducted as penalty.
                </li>
              </ul>
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '15px' }}>
          <p><strong>3. Work Hours:</strong></p>

          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Employees must adhere to their regular work hours while working from home. Availability during working hours is mandatory.
            </li>
          </ul>
        </section>
        <section style={{ marginBottom: '15px' }}>
          <strong>4. Communication:</strong>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Employees must remain reachable via email, phone, and messaging platforms throughout the WFH day.</li>
            <li>Regular checking and status updates should be maintained with the team.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '15px' }}>
          <strong>5. Workspace Requirements:</strong>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Employees must ensure a suitable and productive workspace at home, free from distractions.</li>
            <li>Reliable internet access is mandatory to maintain connectivity and productivity.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '15px' }}>
          <strong>6. Security and Compliance:</strong>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Employees must adhere to all company data security policies while working from home.</li>
            <li>Confidential company information must be handled with the same level of security as in the office.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '15px' }}>
          <strong>7. Performance Expectations:</strong>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Approved WFH must not result in you loosing your job due to lack of performance. No future WFH will be granted to such individuals.</li>
            <li>Employees are expected to maintain the same level of productivity and performance while working from home.</li>
            <li>Deliverables and deadlines remain unchanged unless otherwise communicated.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '15px' }}>
          <p><strong>8. Technology and Equipment:</strong></p>

          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Employees are responsible for ensuring their home office setup (computer, software, internet) is adequate for work tasks.
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '15px' }}>
          <strong>9. Reporting:</strong>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Employees must report their daily activities and tasks completed in their respective work log tracker at the end of each WFH day.</li>
            <li>Any issues or challenges encountered should be communicated promptly.</li>
          </ul>
        </section>


        <section style={{ marginBottom: '15px' }}>
          <strong>10. Wedding:</strong>
          <ul style={{ paddingLeft: '20px', marginTop: '8px', lineHeight: '1.6' }}>
            <li>
              Employees are entitled to take a maximum of 1 week of WFH for the purpose of wedding.
            </li>
            <li>
              This 1 week of WFH will be counted against the 12 annual WFH days permitted for the employee.
            </li>
          </ul>
        </section>

        <section style={{ marginTop: '20px', padding: '15px', border: '1px solid #ff4444', borderRadius: '8px', background: 'rgba(255, 68, 68, 0.05)' }}>
          <strong>11. Exceptions:</strong>
          <p>Exceptions: There are no exceptions to this WFH policy. WFH is very difficult request to be approved. A strong reason which your manager can agree to is mandatory.</p>
        </section>

        <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
          WFH POLICY-R00-01/MAR/2026
        </div>
      </div>
    )
  },
  {
    id: 3,
    title: "General Policy",
    icon: "📅",
    content: (
      <div className="policy-details-text">
        <header className="policy-header-container">

        </header>
        <section>
          <strong>1. Leave Entitlements</strong>
          <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
            <li>The employee is entitled to take 12 days of paid sick leaves (SL) in a year, 11 days of earned leaves (EL) in a year which is earned in proportion to total months of service has been completed.</li>
            <li>The Sick Leave (SL) and Earned Leave (EL) will be prorated based on your joining date. E.g. If your joining date is 13th June, your account will show 10 days of SL available for that financial year and accordingly EL will be accumulated with every month of your service at Genesis except for the month of March.</li>
            <li>Employees will be entitled to 10 public holidays mentioned under the leave policy every financial year</li>
          </ul>
        </section>

        <section>
          <p><strong>2. Carry Forward Rules</strong></p>
          <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
            <li>Other than the earned leaves, the employee cannot carry forward any leaves to next year.</li>

            <li>Genesis Tech will encash the total available earned leaves at the time of leaving the company.</li>
          </ul>
        </section>

        <section>
          <p><strong>3. Encashment Limit</strong></p>
          <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
            <li>Maximum number of earned leaves that can be carried forward over the period of service is 45 days.</li>
          </ul>
        </section>

        <section>
          <p><strong>4. Consecutive leaves:</strong></p>
          <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
            <li>Maximum number of leaves that can be taken together in one slot – 1wk (5 business days)</li>

            <li>Consecutive leaves beyond 2 days must be applied as earned leave.</li>
          </ul>
        </section>

        <section>
          <p><strong>5. Leave quota:</strong></p>
          <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
            <li>Any leaves taken beyond your allocated leave balance will be considered unpaid and will result in pay deduction.</li>

            <li>Earned leaves are earned 1 per month of service completed except in the month of March.</li>
          </ul>
        </section>

        <section>
          <p><strong>6. Sick Leaves</strong></p>

          <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
            <li>
              Sick leaves up to 2 days do not require any medical certificate/documentation to be provided and can be applied as sick leave.
            </li>

            <li>
              Medical leaves greater than 2 days consecutively will mandatorily require medical documentation to be submitted for it to be considered as sick leave. Medical leaves greater than 2 days may fall into one of the following two categories-

              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>

                <li>
                  <strong>Pre-planned medical leave</strong>

                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>This includes any planned medical appointments that you are already aware of or any medical emergency you face.</li>
                    <li>Employees must submit the medical certificate/prescription note latest within 2 days of returning from leave for the leave to be considered as sick leave.</li>
                    <li>Process to apply:

                      <ul style={{ listStyleType: "square", paddingLeft: "20px" }}>
                        <li>Apply for sick leave in the system before going on leave.</li>
                        <li>It will auto change to Earned Leave upon submission.</li>
                        <li>Once you come back from leave you have 2 days to submit the medical documentation proof.</li>
                        <li>You will have to log in back to the system and upload the documentation.</li>
                        <li>Notification will go to the manager and once they accept the proof your leave will be converted from earned leave to sick leave.</li>
                        <li>Failure to submit medical documentation within 2 days of return will result in the leave to be considered as earned leave.</li>
                      </ul>

                    </li>
                  </ul>
                </li>

                <li>
                  <strong>Non-pre-planned medical leaves:</strong>

                  <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
                    <li>You are not expected to apply for these leaves before going on leave as this is scenario of emergency and we are aware you may not have laptop access.</li>
                    <li>Process to apply:

                      <ul style={{ listStyleType: "square", paddingLeft: "20px" }}>
                        <li>This is backdated leave.</li>
                        <li>Apply for sick leave in the system within 2 days of rejoining the work.</li>
                        <li>As this is post the medical event we expect you to have medical documentation proof ready before you apply.</li>
                        <li>At the time of application, you must upload the medical documentation proof.</li>
                        <li>Failure to do so will change the leave to a earned leave category.</li>
                      </ul>

                    </li>
                  </ul>
                </li>

                <li>
                  <strong>Note:</strong> Notification will go to the manager and once they accept the proof your leave will be converted from earned leave to sick leave.
                </li>

              </ul>
            </li>
          </ul>
        </section>

        <section>
          <p><strong>7. Professionalism and respecting others personal time:</strong></p>

          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Stop sending messages on weekends:
              <ol style={{ paddingLeft: "20px", marginTop: "6px" }}>
                <li>Asking for leave on Monday.</li>
                <li>Being delayed to office on any workday particularly Monday.</li>
              </ol>
            </li>

            <li>
              If it is extremely urgent call your manager.
            </li>
          </ul>
        </section>

        <section>
          <p><strong>8. Leave requests and documentation:</strong></p>

          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Employee must request leave through GTELinq and add notification to customers calendar and messaging portals like teams and outlook upon leave being approved and prior to going on OOP.
              <ul style={{ paddingLeft: "20px", marginTop: "6px" }}>
                <li>
                  <em>e.g. If you need 2 days’ leave, you must get leave approved with GTELinq and calendar OOP posted 2 working days prior to going on leave.</em>
                </li>
              </ul>
            </li>

            <li>
              Leaves must be requested, not demanded.
            </li>
          </ul>
        </section>

        <section>
          <p><strong>9. Other leaves:</strong></p>

          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              <strong>Maternity Leave:</strong>
              <ul style={{ paddingLeft: "20px" }}>
                <li>Female employees are entitled to 26 weeks of paid maternity leave.</li>
                <li>These leaves can be taken during the duration of your pregnancy and post childbirth.</li>
                <li>Employee can decide the timing of leaves that is most suitable to them.</li>
                <li>The leave must be taken within 1 year of the childbirth.</li>
                <li>The maternity leaves granted are in addition to the annual leaves that employees are entitled to.</li>
              </ul>
            </li>

            <li>
              <strong>Paternity Leave:</strong>
              <ul style={{ paddingLeft: "20px" }}>
                <li>Male employees are entitled for 2 weeks of paid paternity leave.</li>
                <li>The leave must be taken within 1 year of the childbirth.</li>
                <li>The paternity leaves granted are in addition to the annual leaves that employees are entitled to.</li>
                <ul style={{ paddingLeft: "20px" }}>
                  <li>These will be accounted towards the sick leave based on the available pending leaves you may have and remaining will be deducted from earned leaves.</li>
                </ul>
              </ul>
            </li>


            <li>
              <strong>Engagements/Weddings:</strong>
              <ul style={{ paddingLeft: "20px" }}>
                <li>Employees are entitled to take 2 weeks of time off in total for the purpose of engagement/wedding.</li>
                <ul style={{ paddingLeft: "20px" }}>
                  <li>Note: 2 weeks is the combined allowed maximum time off for both the events.</li>
                </ul>
                <li>The leaves granted are considered towards the annual leaves that employees are entitled to.</li>
                <ul style={{ paddingLeft: "20px" }}>
                  <li>These will be accounted towards the earned leave quota.</li>
                </ul>
              </ul>
            </li>

            <li>
              Half day leaves are allowed. Any leaves that are requested for duration less than half day will by default be considered as half day leave request.
            </li>
          </ul>
        </section>

        <section className="policy-note-red">
          <p><strong>10. Misuse of leaves:</strong></p>

          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Any employee found misusing the leave policy such as frequent absentees, violating break times, presenting fraudulent medical certificates, taking leaves without approval, etc., will undergo disciplinary action along with a pay cut.
            </li>
          </ul>
        </section>





        <section>
          <p><strong>11. Punctuality:</strong></p>

          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Office timing is 3:30pm - 12:30am. In a month, you are allowed to come 10 mins late for a maximum of 2 times without any penalty.
            </li>

            <li>
              If you are late more than 2 times a month, 2 days of earned leaves (EL) will be deducted.
            </li>

            <li>
              When an employee does not have any EL in their bucket, 2 sick leaves will be deducted.
            </li>
            <li>If the employee neither has sick leave nor earned leave, it will result into penalty of 2 days pay cut.</li>
          </ul>

        </section>



        <section>
          <p style={{ marginTop: "5px" }}><strong>12. Thumb Machine Guidelines</strong></p>

          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>You are required to punch in at the time of:</li>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
              <li>Coming to office and leaving office.</li>
              <li>Taking your break and after coming back from break.</li>
            </ul>
            <li>All employees must ensure that they place the thumb properly on the device. You should see a green tick appear when you place the thumb.</li>
            <li>In case where green tick has not appeared, please check with the Genesis IT Team.</li>
            <li>In case an exception is granted for you to WFH, you must write an email to HR to adjust the thumb data manually by clearly mentioning the date in your email. CC your manager in that email.</li>
          </ul>
        </section>
        <section>
          <p><strong>13. Breaks:</strong></p>

          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Dinner break is 7:30pm to 8:30pm. If there is an exception meeting during this hour, you can shift your break. Inform your manager when you plan on shifting your break hour with a reason for doing so.
            </li>

            <li>
              There is no 10-minute buffer for punching back in post break hour.
            </li>
          </ul>
        </section>

        <section>
          <p><strong>14. Monitoring:</strong></p>

          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Emails will be sent to your manager and HR on a monthly basis, with you copied on the email, when punch-in and break timings are not followed punctually.
            </li>
          </ul>
        </section>


        <section>
          <p><strong>15. Return of Original Documents:</strong></p>


          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              The company will withhold educational degree certificates, Marksheets, etc. for the period of the Employment Agreement, i.e., 2 years.
            </li>

            <li>
              Employees completing their 2 years at Genesis must collect their original documents from HR.
            </li>

            <li>
              At the time of document collection, HR will issue you a letter stating the return of documents submitted at the time of joining.
            </li>
          </ul>
        </section>



        <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
          GENERAL POLICY-R00-01/MAR/2026
        </div>
      </div>
    )
  },




  {
    id: 4,
    title: "Out of Office (OOO) Policy",
    icon: "🛡️",
    content: (
      <div className="policy-details-text">
        <header className="policy-header-container">

        </header>
        <section>
          <p><strong>Purpose:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              The Out of Office policy provides guidelines for employees to follow when they are unable to perform their duties due to absence from the workplace. This policy aims to ensure effective communication and continuity of operations during employee absences.
            </li>
          </ul>
        </section>

        <section>
          <p><strong>Policy Overview:</strong></p>

          <p><strong>1. Notification Requirement:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Employees must notify their supervisor and relevant team members of their upcoming absence at least [X days] in advance. This notice should include the start and end dates of the absence and the reason for the absence. X days – Total number of weekdays you are OOP.
            </li>
          </ul>

          <p><strong>2. Penalization for Noncompliance:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Employees who fail to put OOP and their respective leave in the GTELINQ
              portal will be penalized by deducting N+1 days of leave from their earned
              leave account (N indicates the number of days they are OOP).
            </li>

            <li>
              Example: If an employee missed adding leaves for 1 day,
              1 + 1 = 2 Earned Leaves will be deducted from their account.
            </li>
          </ul>

          <p><strong>3. Out of Office Message:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>Employees are required to set up an Out of Office email autoresponder that includes the following information:</li>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
              <li>Dates of absence (start and end)</li>
              <li>Reason for absence (if comfortable sharing)</li>
              <li>Alternate contact person/coverage for the duration of absence</li>
              <li>A note that the employee will respond to emails upon return</li>
            </ul>
          </ul>

          <p><strong>4. Duration of Absence:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Employees should specify the duration of their absence clearly. For longer absences (more than [X days]), employees are encouraged to discuss their workload and responsibilities with their supervisor beforehand.
            </li>
          </ul>

          <p><strong>5. Emergency Contacts:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              If urgent matters arise during the employee's absence, the autoresponder should provide an alternative contact person who can assist in their absence.
            </li>
          </ul>

          <p><strong>6. Return Notification:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Employees should notify their supervisor and team upon their return to the office. This ensures that everyone is aware of their availability and can resume regular communications.
            </li>
          </ul>

          <p style={{ margin: "15px 0 5px 0" }}><strong>7. Documentation:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6", marginTop: "0" }}>
            <li>
              For planned absences (e.g., vacations, medical leaves), employees may be required to submit formal documentation (e.g. medical certificates) as per the company’s leave policy.
            </li>
          </ul>
        </section>


        <section className="policy-team-limits" style={{ marginTop: '0px' }}>
          <strong>8. Team-Specific Absence Limits:</strong>

          <ul style={{ paddingLeft: '20px', marginTop: '8px', marginBottom: '10px', lineHeight: '1.6' }}>
            <li>
              The following guidelines specify the maximum number of employees allowed
              to be Out of Office (OOP) & WFH per team at the same time
            </li>
            <li>
              OOP and WFH can occur concurrently within the team for different team members.
            </li>
          </ul>

          <div style={{
            maxWidth: '850px',
            margin: '10px auto',
            overflowX: 'auto'
          }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '0.85rem'
            }}>
              <thead>
                <tr style={{
                  borderBottom: '1px solid rgba(255,255,255,0.2)',
                  textAlign: 'left'
                }}>
                  <th style={{ padding: '7px 10px' }}>Team Name</th>
                  <th style={{ padding: '7px 10px' }}>Max. OOP</th>
                  <th style={{ padding: '7px 10px' }}>Max. WFH</th>
                </tr>
              </thead>

              <tbody>
                {[
                  ["FSP LO / FI IE", "04", "04"],
                  ["DDI OR", "01", "01"],
                  ["DDI AZ", "01", "01"],
                  ["DMS", "01", "01"],
                  ["IQ Program", "02", "02"],
                  ["FI MeGA", "02", "02"],
                  ["FI Elec", "01", "01"],
                  ["FI Structural/PC", "01", "01"],
                  ["LTO", "01", "01"]
                ].map(([team, oopLimit, wfhLimit], idx) => (
                  <tr
                    key={idx}
                    style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}
                  >
                    <td style={{ padding: '7px 10px' }}>{team}</td>
                    <td style={{ padding: '7px 10px', fontWeight: 'bold', color: '#00bcd4' }}>
                      {oopLimit}
                    </td>
                    <td style={{ padding: '7px 10px', fontWeight: 'bold', color: '#00bcd4' }}>
                      {wfhLimit}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <p><strong>9. Responsibilities:</strong></p>

          <p><strong>Employee:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>It is the employee's responsibility to ensure that all necessary notifications are made and that their workload is managed appropriately prior to their absence.</li>
            <li>If OOP is not approved in the system, it is the employee’s responsibility to get it approved by reaching out to their respective managers.</li>
            <li>Based on a first-come, first-served basis, approvals will be processed in the order requests are received.</li>
            <li>Once your OOP is approved in the GTELinq system, ensure that you are putting your OOP in customers’ Outlook and Teams portal.</li>
          </ul>

          <p><strong>Supervisor/Manager:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>Supervisors are responsible for ensuring that team members understand and adhere to this policy.</li>
            <li>They should assist in reallocating tasks if necessary to ensure continuity during absences.</li>
          </ul>
        </section>

        <section>
          <p><strong>10. Coverage:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>The project on which an individual employee is working should always have coverage, and it is the employee’s responsibility to make proper arrangements.</li>
            <li>Future project/task that is assigned to you and has not started yet should also have coverage member listed regardless of its start date being after your return.</li>
            <li>This is because projects/tasks may get pulled in while you are on leave so we want to ensure all projects are properly resourced.</li>
            <li>For projects that have already been completed, there should be general coverage.</li>
          </ul>
        </section>
        <section >
          <p><strong>11. Noncompliance:</strong></p>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
            <li>
              Failure to adhere to the Out of Office policy may result in disciplinary actions such as unpaid leaves with deduction of an equal number of leaves from the earned leaves, as it can disrupt workflow and affect team productivity.
            </li>
          </ul>
        </section>

        <section>
          <strong>12. Major medical emergencies</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>A major medical emergency is scenario which restricts you from coming to work and performing your job duties either from office or work.</li>
            <li>This involves case when you are hospitalized.</li>
            <li>Genesis Tech supports all their employees in times of such emergencies, and we want to make sure employees get every possible support from the team and their manager.</li>
            <li>As you will be away from office for longer than usual duration following scenarios may apply to you on a case-by-case basis.</li>
            <li>The number of days you are OOP will be evaluated against your pending SL and EL and will be adjusted against the pending leaves you have.</li>
            <li>In case you do not have any leaves in the current financial year, it will result in a pay cut.</li>
            <li>Pay deduction may happen for the number of days you were OOP without impacting your leave counts.</li>
            <li>Your manager will discuss this with you once you are back in the office and one appropriate option from above will be applied.</li>
          </ul>
        </section>
        <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
          OUT OF OFFICE (OOO) POLICY-R00-01/MAR/2026
        </div>
      </div>
    )
  },

  {
    id: 5,
    title: "Public Holidays for 2026",
    icon: "🎉",
    content: (
      <div className="policy-details-text">



        <div className="okr-table-wrapper">

          <div style={{ marginBottom: '15px', fontSize: '16px', lineHeight: '1.5' }}>
            <p><strong>Note:</strong></p>
            <ul style={{ paddingLeft: '20px', lineHeight: '1.5', marginTop: '5px' }}>
              <li>Total allowable national holidays in a year are 10.</li>
              <li>Not all festivals get their spot on the holiday calendar every year, as the number of festivals we celebrate across India is more than 10.</li>
              <li>Overall holidays are adjusted to limit to 10, and you may see some holidays which were given in last year may not be in the list to limit the total count of national holidays to 10.</li>
            </ul>
          </div>

          <table className="okr-modern-table" style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '30px' }}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Sr.No</th>
                <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Festival</th>
                <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Date</th>
                <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Day</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["1", "New Year", "1-Jan-2026", "Thursday"],
                ["2", "Republic Day", "26-Jan-2026", "Monday"],
                ["3", "Gudi Padwa", "19-Mar-2026", "Thursday"],
                ["4", "Maharashtra Day", "1-May-2026", "Friday"],
                ["5", "Bakrid", "27-May-2026", "Wednesday"],
                ["6", "Ganesh Chaturthi", "14-Sep-2026", "Monday"],
                ["7", "Gandhi Jayanti", "2-Oct-2026", "Friday"],
                ["8", "Dussehra", "20-Oct-2026", "Tuesday"],
                ["9", "Diwali", "9-Nov-2026", "Monday"],
                ["10", "Christmas", "25-Dec-2026", "Friday"]
              ].map(([sr, fest, date, day], idx) => (
                <tr key={idx}>
                  <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{sr}</td>
                  <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{fest}</td>
                  <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{date}</td>
                  <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{day}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
          PUBLIC HOLIDAY POLICY-R00-01/MAR/2026
        </div>

      </div>
    )
  },
  {
    id: 6,
    title: "Performance Of Duties",
    icon: "⚖️",
    content: (
      <div className="policy-details-text">
        <section>
          <strong>1. Performance Of Duties</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
            <li>The Employee agrees that during the Employment Period, he/she shall devote his/her full business time to the business affairs of the Company and shall perform the duties assigned to him/her faithfully and efficiently, and shall endeavor, to the best of his/her abilities to achieve the goals and adhere to the parameters set by the Company.</li>
          </ul>
        </section>

        <section>
          <strong>2. Responsibilities</strong>
          <p>The Employee shall be responsible for:</p>
          <p style={{ paddingLeft: '20px' }}>• Devoting the whole time, attention and abilities to the business of Genesis Tech Engineers unless prevented by illness.</p>
          <p style={{ paddingLeft: '20px' }}>• Diligently perform such duties as may from time to time be assigned to you.</p>
          <p style={{ paddingLeft: '20px' }}>• Comply with all reasonable and lawful directions given to you by Genesis Tech Engineers and your managers.</p>
          <p style={{ paddingLeft: '20px' }}>• Act in good faith and in the best interest of Genesis Tech Engineers and its customers and staff always, including reporting your own wrongdoing and any wrongdoing of any  other employee immediately on becoming aware of it.</p>
          <p style={{ paddingLeft: '20px' }}>• Promote, Protect, Develop, and extend the business of Genesis Tech Engineers.</p>
          <p style={{ paddingLeft: '20px' }}>• Take all reasonable steps in respect of the help and safety of yourself, colleagues, and third parties.</p>
        </section>

        <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
          PERFORMANCE OF DUTIES POLICY-R00-01/MAR/2026
        </div>

      </div>
    )
  },

  {
    id: 7,
    title: "Fair Compensation",
    icon: "💰",
    content: (

      <div className="policy-details-text">
        <header className="policy-header-container">

        </header>
        <section>
          <p>Subject to the following provisions of this Agreement, during the Employment Period, the Employee shall be compensated for his services as follows. All compensation related activities are based on Financial Year (i.e. Apr -Mar) and not regular calendar year (Jan-Dec). </p>
        </section>

        <section>
          <strong>1. Annual Salary</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
            <li>The Employee shall receive an annual salary, payable monthly by the Employer. Subject to such increases from time to time, as determined by the Employer. Such payments shall be subject to such normal statutory deductions by the Employer.</li>
          </ul>
        </section>

        <section>
          <strong>2. Payment Method</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
            <li>During the term of this Agreement, the Employee's salary shall be paid by means of bank transfer, cheque, or any other method convenient to the Employer, and consented to by the Employee.</li>
          </ul>
        </section>

        <div>
          <strong>3. Term insurance Policy</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
            <li>As a part of your overall CTC package Genesis Tech will work on issuing Term insurance policy for every employee.</li>
            <li>The term insurance policy will be issued anytime between joining to 7month service at Genesis.</li>

            <li>
              <strong>Policy Payments:</strong>
              <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
                <li>The annual installment amount depends on multiple factors and can vary for employee to employee.</li>
                <li>Age, physical condition, medical test reports will define your policy premium value.</li>
              </ul>
            </li>

            <li>As a part of CTC Genesis will bear certain majority portion of your policy (varies for all employees) to match your CTC and employees will be responsible to pay the excess amount.</li>
            <li>The policy duration is 10 years.</li>
            <li>Genesis Tech will keep on paying the annual premium amount util you are employed with Genesis Tech.</li>
            <li>As this is administrative item, for any further questions regarding your insurance policy direct all your questions to HR. Your manager will not have details to your specific policy that applies to you.</li>
          </ul>
        </div>
        <div style={{ marginTop: "25px" }}>
          <strong>4. Annual Bonus:</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
            <li>Annual bonus is awarded in Diwali every year.</li>
            <li>Annual bonus are prorated based on your joining date in a financial year.</li>
            <li>The annual bonus is awarded based on the last financial year service you performed.</li>

            <li>
              Examples below:
              <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
                <li>If an employee joined on 1st June2025, the financial year will end on 31st March 2026 and the employee will get the annual bonus for duration of 1st June 2025 to 31st March 2026 during Diwali of 2026.</li>
                <li>For employees who were employed for full financial year they will get their 1st April 2025 to 31st March 2026 bonus pay in Diwali of 2026.</li>
              </ul>
            </li>

          </ul>
        </div>
        <div style={{ marginTop: "25px" }}>
          <strong>5. Provident Fund:</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
            <li>Provident Fund (PF) has 2 portions employees part and employers part.</li>
            <li>The employees part is deducted from their monthly pay and the deduction is mentioned on your pay slip.</li>
            <li>The employer part is directly deposited into your PF account.</li>
            <li>All employees are encouraged to have UMANG app to check your PF balance and confirm any details you might want to view regarding your PF.</li>
          </ul>
        </div>

        <div style={{ marginTop: "25px" }}>
          <strong>6. Professional Tax:</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '8px' }}>
            <li>Professional Tax (PT) of Rs.200/- per month is deducted from your salary.</li>
            <li>This deduction is also listed on your payslip.</li>
          </ul>
        </div>


        <section style={{ marginTop: '10px' }}>
          <strong>7. Reimbursement Guidlines</strong>
          <p><strong>Definition:</strong> Reimbursement is when you make an expense pre-approved by your manager on behalf of company for official purposes.</p>
          <p>• Employees must log in to the GTELinq portal and submit the reimbursement form.</p>
          <p>• You are required to upload all receipts for your requests.</p>
          <p>• The receipt must be readable.</p>
          <p>• The receipt should be in company name.</p>
          <p>• Where GST billing can be done you should proceed with getting a GST bill.</p>
          <p>• When asking for GST bill you must tell the seller/supplier to enter company’s full name and GST number to be included on the bill/receipt. Details are as follows:</p>
          <div style={{ paddingLeft: '20px', margin: '10px 0' }}>
            <strong>Name:</strong> GENESIS TECH ENGINEERS PVTD LTD.<br />
            <strong>GST NO.:</strong> 27AAKCG7985R1ZB
          </div>
          <p>• The bill must be submitted in the same month within 2 days of making the transaction.</p>
          <p>• The reimbursement will be routed to your manager for approval.</p>
          <p>• Once manager approves the money will be deposited in the current month pay cycle.</p>
          <p>• If the pay cycle is within 7 days of submitting the bill the payment will be released in the following pay cycle.</p>
        </section>
        <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
          FAIR COMPENSATION POLICY-R00-01/MAR/2026
        </div>
      </div>
    )
  },
  {
    id: 8,
    title: "Obligations of the Employee",
    icon: "📝",
    content: (


      <div className="policy-details-text">
        <header className="policy-header-container">

        </header>


        <section>
          <strong>1. Legal Conduct</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              Upon execution of the employment agreement, the Employee shall not engage in any sort of theft, fraud, misrepresentation, or any other illegal act neither in the employment space nor outside the premise of employment. If he/she does so, the Company shall not be liable for such acts done at his/her own risk.
            </li>
            <li>
              The Employee further promises to never engage in any theft of the Employer’s property or attempt to defraud the Employer in any manner.
            </li>
          </ul>
        </section>

        <section>
          <strong>2. Compliance with Rules</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations, and policies of the Company as notified from time to time.
            </li>
          </ul>
        </section>

        <section>
          <strong>3. Exclusive Service</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              The Employee shall not take up part-time or full-time employment or consultation with any other party or be involved in any other business during the term of his/her employment with the Company.
            </li>
          </ul>
        </section>

        <section>
          <strong>4. Return of Property</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              On termination, the Employee shall immediately return to the Employer all documents, books, materials, records, correspondence, papers and information (on whatever media and wherever located) relating to the Employer’s business or affairs, or relating to the Employer’s business contacts, any keys, credit cards, access cards, and any other property of the Employer, which is in the Employee’s possession or under the Employee’s control.
            </li>
          </ul>
        </section>

        <section>
          <strong>5. Specific Policies</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              The Employee shall always ensure that his/her conduct is in accordance with all the rules, regulations, and policies of the Company as notified from time to time, including but not limited to the Leave Policy and Sexual Harassment Policy.
            </li>
            <li>
              The Employer prohibits the Employee from engaging in any form of sexual harassment and the Employee promises to refrain from any form of sexual harassment during employment in and around the premises of employment. If the Employee violates this term in the agreement, he/she shall be fully responsible for his/her actions, and the Employer shall not be held responsible for any illegal acts committed at the discretion of the Employee.
            </li>
          </ul>
        </section>

        <section>
          <strong>6. Dress Code</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>Monday of every week is formal wear day.</li>
            <li>Other days in the week are casual wears suitable for the office environment.</li>
          </ul>
        </section>

        <section>
          <strong>7. Use of common areas in building premises and offices:</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>Common building spaces must be used hygienically.</li>
            <li>Everyone using the space must ensure they are not causing spills and keep the place clean.</li>
          </ul>
        </section>

        <section>
          <strong>8. ID Cards:</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>ID cards are compulsory in the office. You must wear them at all times while on the building campus.</li>
          </ul>
        </section>
        <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
          OBLIGATION OF THE EMPLOYEE POLICY-R00-01/MAR/2026
        </div>
      </div>
    )
  },
  {
    id: 9,
    title: "Assignments",
    icon: "📋",
    content: (
      <div className="policy-details-text">
        <header className="policy-header-container">
          {/* <h2 className="policy-main-title">Assignment</h2> */}
        </header>

        <section>
          <strong>1. Works Made for Hire</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              The Employee acknowledges that any work including, without limitation, inventions, designs, ideas, concepts, drawings, working notes, artistic works that the Employee may individually or jointly conceive or develop during the term of Employment are “works made for hire.”
            </li>
            <li>
              To the fullest extent permitted by law, the Employee shall assign, and does hereby assign, to the Employer all of the Employee's right, title, and interest in and to all Intellectual Property improved, developed, discovered, or written in such works.
            </li>
          </ul>
        </section>

        <section>
          <strong>2. Documentation and Vesting</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              The Employee shall, upon request of the Employer, execute, acknowledge, deliver, and file any and all documents necessary or useful to vest in the Employer all of the Employee's right, title, and interest in and to all such matters.
            </li>
          </ul>
        </section>
        <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
          ASSIGNMENTS POLICY-R00-01/MAR/2026
        </div>
      </div>
    )
  },
  {
    id: 10,
    title: "Confidentiality",
    icon: "🔒",
    content: (
      <div className="policy-details-text">
        <header className="policy-header-container"></header>

        <section>
          <strong>1. Access to Information</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              The Employee acknowledges that, while performing and fulfilling his/her duties hereunder, he/she may have access to and be entrusted with confidential information concerning the present and contemplated financial status and activities of the Employer.
            </li>
            <li>
              The disclosure of any of this confidential information to competitors of the Employer would be highly detrimental to the interests of the Employer.
            </li>
          </ul>
        </section>

        <section>
          <strong>2. Proprietary Rights</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              The Employee further acknowledges and agrees that the right to maintain the confidentiality of trade secrets, source code, website information, business plans, client information, or other confidential or proprietary information constitutes a proprietary right.
            </li>
            <li>
              The Employer is entitled to protect this proprietary right.
            </li>
          </ul>
        </section>

        <section>
          <strong>3. Non-Disclosure Covenant</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              The Employee covenants and agrees that he/she will not, under any circumstance during the continuance of this agreement, disclose any such confidential information to any person, firm, or corporation.
            </li>
            <li>
              The Employee shall not use the confidential information except as required in the normal course of engagement.
            </li>
            <li>
              Even after termination of employment, the Employee shall not disclose or make use of the confidential information, nor cause it to be disclosed in any manner.
            </li>
          </ul>
        </section>

        <section>
          <strong>4. Intellectual Property Ownership</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              The Employer owns any intellectual property created by the Employee during employment, or in relation to a certain field, and has all necessary rights to retain it.
            </li>
            <li>
              After termination of employment, the Employee shall not claim any rights on the intellectual property created.
            </li>
            <li>
              Any source code, software, or other intellectual property developed, including website design or functionality created by the Employee during employment under this Agreement, shall belong to the Employer.
            </li>
          </ul>
        </section>

        <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
          CONFIDENTIALITY POLICY-R00-01/MAR/2026
        </div>
      </div>
    )
  },



  {
    id: 11,
    title: "Employee Termination",
    icon: "🚫",
    content: (
      <div className="policy-details-text">
        <header className="policy-header-container"></header>

        <section>
          <strong>1. Employer Termination</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>The Employer may terminate your employment without any notice.</li>
          </ul>
        </section>

        <section>
          <strong>2. Employee Resignation</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>The Employee may terminate his/her employment by providing the Employer with at least 2-month(s) advance notice of his/her intention to resign.</li>
          </ul>
        </section>


        <section>
          <strong>3. Notice Period</strong>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
            <li>
              For employees wishing to terminate their employment with Genesis Tech will be considered to opt for one of the two options listed below:
              <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
                <li>Immediate termination (0 Day notice period served)</li>
                <li>Full notice period served (60 Day notice period served)</li>
              </ul>
              Based on option that employee chooses the following process will be applicable to complete employees exit procedures.
            </li>
          </ul>
        </section>


        <section>
          <strong>4. Exit Procedure Policy</strong>
          <div style={{ marginTop: '20px' }}>
            <strong>Case 1:</strong>

            <p style={{ marginTop: '10px' }}>
              A clean exit procedure at GTE is meeting the following 2 criteria listed-
            </p>

            <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
              <li>Service Agreement Duration: 2 years</li>
              <li>Notice period: 2 months post completion of service agreement.</li>
            </ul>

            <p style={{ marginTop: '10px' }}>
              If the above criteria is met, the process will occur in following sequence-
            </p>

            <p style={{ marginTop: '15px' }}><strong>Documentation</strong></p>
            <p style={{ marginTop: '5px' }}>
              GTE will provide you with following documentation as a part of exit procedures-
            </p>
            <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
              <li>Relieving Letter</li>
              <li>Experience Letter</li>
              <li>Payslip of last month of service at GTE</li>
              <li>Handover of any original documents submitted</li>
              <li>Signing of form stating receipt of original documents (A copy will be provided to employee)</li>
            </ul>

            <p style={{ marginTop: '15px' }}><strong>Finances</strong></p>
            <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
              <li>Pay for last month of employment at GTE.</li>
              <li>Payment of earned leaves accumulated while being at GTE.</li>
            </ul>

            <p style={{ marginTop: '15px' }}>
              The documentation and financial settlement will take place within 2 business days.
            </p>
          </div>

          <section>
            <strong>Notice Period Violation:</strong>
            <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
              <li>
                In the event where notice period could not be served by the employee, they must discuss with their manager a plan of exiting immediately by paying 2 months of your pay for notice period duration. Once the payment is made you will be entitled to receive the following documents:
                <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>
                  <li>Relieving Letter</li>
                  <li>Experience Letter</li>
                  <li>Return of original documents submitted at the time of joining</li>
                  <li>Pay and Payslip of your last month of service at GTE</li>
                </ul>
              </li>


            </ul>
          </section>

          <div style={{ marginTop: '20px' }}>
            <strong>Case 2:</strong>

            <p style={{ marginTop: '10px' }}>Any duration which is less than 2 years of service agreement.</p>

            <p style={{ marginTop: '10px' }}>
              In event when you choose to leave prior to end of your service agreement duration, you are required to complete the 2 months’ notice period as a mandatory requirement.
            </p>

            <p style={{ marginTop: '10px' }}>The process will occur in following sequence-</p>

            <p style={{ marginTop: '15px' }}><strong>Finances</strong></p>
            <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
              <li>GTE will recover the cost for time invested in training.</li>
              <li>This is 6 months of your pay (your probation duration).</li>
              <li>GTE will send pending dues notice for the same.</li>
            </ul>

            <p style={{ marginTop: '15px' }}>Until the above criteria is satisfied all the items below will be withheld.</p>
            <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
              <li>Pay for last month of employment.</li>
              <li>Payment of earned leaves accumulated.</li>
            </ul>

            <p style={{ marginTop: '15px' }}>
              The above payments will be used against your financial dues and the financial dues notice will include all the respective details.
            </p>

            <p style={{ marginTop: '15px' }}><strong>Documentation on hold</strong></p>
            <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
              <li>Relieving Letter</li>
              <li>Experience Letter</li>
              <li>Return of original documents submitted at the time of joining.</li>
              <li>Payslip of last month of service at GTE</li>
            </ul>


            <section>
              <strong>Notice Period Violation:</strong>
              <ul style={{ paddingLeft: '20px', lineHeight: '1.6', marginTop: '5px' }}>

                <li>
                  You are liable to follow the requirements mentioned under the section “Case 2” along with additional payment of 2 months of notice period to be considered for a complete exit procedure.
                </li>
                <li>GTE will not allow you to serve partial duration of notice period.</li>
              </ul>
            </section>
          </div>

          <div style={{ marginTop: '15px', paddingTop: '15px' }}>
            <p><strong>5. In the event where any of the above conditions are not met the employee is not entitled to receive:</strong></p>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Relieving Letter.</li>
              <li>Experience Letter.</li>
              <li>Return of original documents submitted at the time of joining.</li>
              <li>Pay and Payslip of your last month of service at GTE.</li>
            </ul>
          </div>

          <div style={{ marginTop: '15px' }}>
            <p><strong>6. Employee Responsibility:</strong></p>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Schedule a 1:1 with your manager and discuss your departure plan.</li>
              <li>Send official email of resignation to hr@genesistech.co.in with your manager copied on the email.</li>
              <li>Make sure all office belongings are returned back to your manager. This includes your laptop, charger, headset, notebooks, notes in any form etc.</li>
            </ul>
          </div>

          <div style={{ marginTop: '15px' }}>
            <p><strong>7. Manager’s responsibilities:</strong></p>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Ensure all the above things are met in order for successful completion of employee relieving process.</li>
            </ul>
          </div>
        </section>



        <div style={{ marginTop: '30px', borderTop: '1px solid #444', paddingTop: '10px', fontSize: '11px', color: '#888', textAlign: 'right' }}>
          EMPLOYEE TERMINATION POLICY-R00-01/MAR/2026
        </div>
      </div>
    )
  }


];

const CompanyPolicy = ({ userData }) => {
  const [companyLogo, setCompanyLogo] = useState("");
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [logs, setLogs] = useState({});
  const [loading, setLoading] = useState(false);

  const empBadgeId = userData?.EmpId || userData?.employeeId;
  const fullName = `${userData?.FirstName || ''} ${userData?.LastName || ''}`.trim();
  const API_URL = "/gt-api/acknowledgepolicy.php";

  useEffect(() => {
    const fetchMyLogs = async () => {
      if (!empBadgeId) return;

      try {
        const response = await fetch(`${API_URL}?empId=${empBadgeId}`);
        const result = await response.json();

        const logsArray = result.logs || [];

        const signedMap = logsArray.reduce((acc, curr) => {
          if (curr.policy_title) {
            acc[curr.policy_title] = true;
          }
          return acc;
        }, {});

        setLogs(signedMap);

      } catch (e) {
        console.error("Failed to load policy signatures:", e);
      }
    };

    fetchMyLogs();
  }, [empBadgeId]);

  const handleReadStatus = async (policyTitle) => {
    if (!empBadgeId) {
      alert("User Session Missing: EmpId not found. Please log out and back in.");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          empId: empBadgeId,
          fullName: fullName,
          policyTitle: policyTitle
        }),
      });
      const result = await response.json();
      if (result.status === "success") {
        setLogs(prev => ({ ...prev, [policyTitle]: true }));
      } else {
        alert("Server Error: " + (result.message || "Could not save."));
      }
    } catch (error) {
      alert("Failed to connect to the server.");
    } finally {
      setLoading(false);
    }
  };

  const isRead = (title) => logs[title] || false;

  const [companyPolicies, setCompanyPolicies] = useState([]);
  const isGenesis =
    userData?.EmailId?.toLowerCase().includes("genesistech.co.in") ||
    userData?.EmailId?.toLowerCase().includes("gtecorpgroup.com") ||
    userData?.EmailId?.toLowerCase().includes("gtcorpgroup.com");
  useEffect(() => {
    if (isGenesis) return;

    fetch(
      "/gt-api/get_policies.php",
      {
        credentials: "include"
      }
    )
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setCompanyPolicies(data.policies || []);
        }
      });
  }, [isGenesis]);

  useEffect(() => {
    const email = userData?.EmailId || "";
    const domain = email.split("@")[1]?.toLowerCase();
    if (!domain) return;

    fetch(
      "/gt-api/get_company_logo.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ domain })
      }
    )
      .then(res => res.json())
      .then(data => {
        if (data.success && data.company_logo) {
          setCompanyLogo(
            `/gt-api/${data.company_logo}`
          );
        }
      })
      .catch(console.error);
  }, [userData]);

  const policies = isGenesis
    ? GENESIS_POLICIES
    : companyPolicies;

  return (
    <div className="policy-wrapper">

      {/* ================= DESKTOP VIEW ================= */}
      <div className="desktop-policy-layout">

        {/* Sidebar */}
        <div className="policy-sidebar-nav glass">
          <div className="sidebar-header"></div>

          <div className="policy-menu">
            {policies.map((p) => (
              <div
                key={p.id}
                className={`policy-item ${selectedPolicy?.id === p.id ? "active" : ""
                  }`}
                onClick={() => setSelectedPolicy(p)}
              >
                <div className="active-indicator"></div>

                <span className="p-icon">
                  {isGenesis ? p.icon : p.policy_icon}
                </span>

                <span className="p-text">
                  {isGenesis ? p.title : p.policy_title}
                </span>

                {isRead(
                  isGenesis ? p.title : p.policy_title
                ) && <span className="p-status-check">✅</span>}
              </div>
            ))}
          </div>
        </div>

        {/* Viewer */}
        <div className="policy-viewer glass">
          {selectedPolicy ? (
            <div className="viewer-content animate-fade">

              <div className="viewer-header">
                <div className="header-info">
                  <h1>
                    {isGenesis
                      ? selectedPolicy.title
                      : selectedPolicy.policy_title}
                  </h1>
                </div>
              </div>

              <div className="cyber-divider"></div>

              <div className="document-body">
                <section className="doc-section">

                  {isGenesis ? (
                    selectedPolicy.content
                  ) : (
                    <div
                      style={{ lineHeight: "1.9" }}
                      dangerouslySetInnerHTML={{
                        __html: selectedPolicy.policy_content
                          .split("\n")
                          .map((line) => {
                            const trimmed = line.trim();

                            if (!trimmed) return "<br>";

                            if (/^\d+\./.test(trimmed)) {
                              return `<br><strong>${trimmed}</strong><br>`;
                            }

                            return `• ${trimmed}<br>`;
                          })
                          .join("")
                      }}
                    />
                  )}

                </section>

                <div
                  className="acknowledgement-section"
                  style={{
                    marginTop: "40px",
                    padding: "20px",
                    backgroundColor: "rgba(255,255,255,0.05)",
                    borderRadius: "8px",
                    textAlign: "center"
                  }}
                >
                  <button
                    className={`read-button ${isRead(
                      isGenesis
                        ? selectedPolicy.title
                        : selectedPolicy.policy_title
                    )
                      ? "disabled"
                      : ""
                      }`}
                    onClick={() =>
                      handleReadStatus(
                        isGenesis
                          ? selectedPolicy.title
                          : selectedPolicy.policy_title
                      )
                    }
                    disabled={isRead(
                      isGenesis
                        ? selectedPolicy.title
                        : selectedPolicy.policy_title
                    )}
                  >
                    {isRead(
                      isGenesis
                        ? selectedPolicy.title
                        : selectedPolicy.policy_title
                    )
                      ? "✓ Policy Acknowledged"
                      : "Read and Understood"}
                  </button>
                </div>
              </div>

              <div className="policy-footer">
                {/* <p>© Genesis Tech Engineers Pvt. Ltd.</p> */}
              </div>

            </div>
          ) : (
            <div className="empty-policy-wrapper">
              <div className="empty-policy-state">
                <img
                  src={companyLogo || logoWhite}
                  alt="Company Logo"
                  style={{
                    width: "350px",
                    height: "auto",
                    marginBottom: "80px"
                  }}
                />

                <p className="empty-policy-text">
                  PICK A POLICY FROM THE SIDEBAR TO READ IT.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ================= MOBILE VIEW ================= */}

      {!selectedPolicy ? (
        <div className="mobile-policy-list">

          {policies.map((p) => (
            <div
              key={p.id}
              className="mobile-policy-card"
              onClick={() => setSelectedPolicy(p)}
            >
              <div className="mobile-policy-header">

                <span className="mobile-policy-icon">
                  {isGenesis ? p.icon : p.policy_icon}
                </span>

                <span className="mobile-policy-title">
                  {isGenesis ? p.title : p.policy_title}
                </span>

              </div>

              {isRead(
                isGenesis ? p.title : p.policy_title
              ) && (
                  <div className="mobile-policy-status">
                    ✅ Acknowledged
                  </div>
                )}
            </div>
          ))}

        </div>
      ) : (
        <div className="mobile-policy-viewer">

          <button
            className="mobile-policy-back-btn"
            onClick={() => setSelectedPolicy(null)}
          >
            ← BACK TO POLICIES
          </button>

          <h2 className="mobile-policy-heading">
            {isGenesis
              ? selectedPolicy.title
              : selectedPolicy.policy_title}
          </h2>

          <div className="mobile-policy-content">

            {isGenesis ? (
              selectedPolicy.content
            ) : (
              <div
                style={{ lineHeight: "1.9" }}
                dangerouslySetInnerHTML={{
                  __html: selectedPolicy.policy_content
                    .split("\n")
                    .map((line) => {
                      const trimmed = line.trim();

                      if (!trimmed) return "<br>";

                      if (/^\d+\./.test(trimmed)) {
                        return `<br><strong>${trimmed}</strong><br>`;
                      }

                      return `• ${trimmed}<br>`;
                    })
                    .join("")
                }}
              />
            )}

          </div>

          <div className="acknowledgement-section mobile-ack">

            <button
              className={`read-button ${isRead(
                isGenesis
                  ? selectedPolicy.title
                  : selectedPolicy.policy_title
              )
                ? "disabled"
                : ""
                }`}
              onClick={() =>
                handleReadStatus(
                  isGenesis
                    ? selectedPolicy.title
                    : selectedPolicy.policy_title
                )
              }
              disabled={isRead(
                isGenesis
                  ? selectedPolicy.title
                  : selectedPolicy.policy_title
              )}
            >
              {isRead(
                isGenesis
                  ? selectedPolicy.title
                  : selectedPolicy.policy_title
              )
                ? "✓ Policy Acknowledged"
                : "Read and Understood"}
            </button>

          </div>

        </div>
      )}

    </div>
  );
};

export default CompanyPolicy;




